import React from 'react';
import { ReactComponent as Shift } from './shift.svg';
import { ReactComponent as DeleteSticker } from './icon-delete-sicker.svg';

export const AssetIcon: {
  [key: string]: React.FC<React.SVGProps<SVGSVGElement>>;
} = {
  Shift,
  DeleteSticker,
  HandClickerIcon: (props) => (
    <svg
      width="91"
      height="72"
      viewBox="0 0 91 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M53.0349 27.3604C56.1649 24.2204 59.3049 21.0704 62.4549 17.9404C64.9049 15.5104 68.8949 15.5704 71.2849 18.0404C73.6249 20.4704 73.4949 24.2504 70.9549 26.8004C64.3849 33.3804 57.8149 39.9504 51.2449 46.5304C51.0549 46.7204 50.7949 46.8704 50.6949 47.2104C51.1949 47.2604 51.6749 47.2704 52.1449 47.3704C54.7949 47.9304 56.7249 49.9804 57.0449 52.5204C57.3849 55.2304 56.0949 57.6304 53.6349 58.9104C47.2749 62.2104 40.9349 65.5604 34.5549 68.8104C28.0349 72.1304 21.3949 72.2804 14.7249 69.2904C10.9849 67.6104 8.13493 64.8004 5.50493 61.7704C-1.60507 53.5804 -1.41507 40.6704 5.98493 32.7304C8.81493 29.6904 11.8249 26.8104 14.7649 23.8704C17.4949 21.1304 20.2249 18.3804 22.9849 15.6604C25.8449 12.8504 30.3849 13.2804 32.5449 16.5204C33.0749 17.3204 33.3449 18.2304 33.5549 19.2104C35.5149 18.1604 37.4749 17.9704 39.4749 18.8904C41.5149 19.8304 42.5749 21.5204 42.9549 23.6904C47.0549 21.5304 51.4149 23.5904 52.5549 28.0604C52.7149 27.8304 52.8449 27.5604 53.0449 27.3604M8.42493 61.3704C10.3149 63.2804 12.1749 65.2204 14.5949 66.4804C20.9549 69.7904 27.3349 69.8404 33.7149 66.5104C39.5649 63.4604 45.4249 60.4204 51.2849 57.3804C51.7849 57.1204 52.2949 56.8704 52.7849 56.5904C54.5549 55.5604 55.1849 53.3904 54.2249 51.6304C53.2449 49.8404 51.1249 49.1604 49.2949 50.0604C48.2049 50.6004 47.1449 51.1704 46.0649 51.7204C45.2449 52.1404 44.5949 52.0504 44.2049 51.4604C43.8349 50.9004 43.9549 50.3204 44.5949 49.6804C52.8249 41.4404 61.0649 33.2104 69.2949 24.9704C71.0649 23.2004 70.8849 20.6004 68.9249 19.1904C67.4749 18.1504 65.4749 18.3404 64.1149 19.6904C61.4049 22.3804 58.7049 25.0904 56.0049 27.7904C51.5849 32.2104 47.1649 36.6304 42.7449 41.0504C42.5449 41.2504 42.3549 41.4704 42.1349 41.6404C41.6149 42.0604 40.8749 42.0304 40.4549 41.5804C39.9949 41.0904 39.9749 40.4304 40.4449 39.9004C40.7149 39.5904 41.0249 39.3104 41.3149 39.0204C43.8149 36.5204 46.3249 34.0204 48.8149 31.5104C49.9049 30.4204 50.1949 29.1004 49.7049 27.6604C49.2249 26.2404 48.1749 25.4204 46.6849 25.2304C45.3949 25.0604 44.3149 25.5304 43.4049 26.4504C40.2249 29.6304 37.0549 32.8104 33.8749 35.9804C33.6949 36.1604 33.5149 36.3604 33.3049 36.5004C32.7949 36.8104 32.2449 36.8004 31.8049 36.3804C31.3649 35.9604 31.2949 35.4304 31.6049 34.9004C31.7449 34.6604 31.9549 34.4504 32.1449 34.2504C34.4949 31.8904 36.8549 29.5404 39.2049 27.1804C40.8749 25.5104 40.9449 23.2904 39.4049 21.7504C37.8949 20.2404 35.5949 20.3304 33.9449 21.9804C31.0949 24.8204 28.2449 27.6704 25.4049 30.5204C24.9249 31.0004 24.4049 31.1604 23.8049 30.8304C23.3149 30.5604 23.1649 30.1004 23.2349 29.5804C23.2849 29.1704 23.5949 28.9104 23.8649 28.6304C25.8349 26.6604 27.8049 24.6804 29.7849 22.7204C30.7549 21.7604 31.3049 20.6304 31.0349 19.2404C30.7649 17.8404 29.9449 16.8504 28.5849 16.3904C27.1049 15.8904 25.7649 16.2704 24.6649 17.3404C22.8949 19.0704 21.1549 20.8404 19.4049 22.5904C15.7549 26.2404 12.0849 29.8804 8.45493 33.5504C4.65493 37.4004 2.77494 42.0804 2.65494 47.5204C2.78493 52.8404 4.60493 57.4904 8.39493 61.3404"
        fill="currentColor"
      />
      <path
        d="M24.2045 71.7596C21.0145 71.7596 17.7945 71.0396 14.5845 69.5996C10.6545 67.8396 7.76448 64.8996 5.24448 61.9896C-1.93552 53.7196 -1.71552 40.4896 5.73448 32.4896C7.74448 30.3396 9.87448 28.2296 11.9245 26.1996C12.7845 25.3496 13.6545 24.4896 14.5145 23.6296L16.1545 21.9796C18.3345 19.7796 20.5245 17.5896 22.7345 15.4196C24.1945 13.9896 26.1545 13.2896 28.1345 13.4896C30.0445 13.6896 31.7545 14.7196 32.8245 16.3296C33.3345 17.0896 33.6045 17.9096 33.7945 18.7096C35.7845 17.7596 37.7345 17.7196 39.6145 18.5796C41.4945 19.4496 42.7045 20.9896 43.1945 23.1796C45.1145 22.2896 47.1345 22.2396 48.9345 23.0396C50.6645 23.8096 51.9945 25.3196 52.6745 27.2596C52.7145 27.2096 52.7545 27.1596 52.8045 27.1196L53.1345 26.7796C56.1545 23.7496 59.1845 20.7096 62.2245 17.6896C63.4545 16.4696 65.0845 15.7996 66.8145 15.7996H66.8845C68.6545 15.8196 70.3045 16.5296 71.5345 17.7996C74.0245 20.3796 73.8745 24.3496 71.1945 27.0296L62.3245 35.9096C58.7045 39.5296 55.0945 43.1396 51.4845 46.7596C51.4345 46.8096 51.3845 46.8596 51.3245 46.9096C51.6145 46.9296 51.9245 46.9596 52.2145 47.0296C55.0145 47.6196 57.0445 49.7596 57.3745 52.4696C57.7345 55.3296 56.3945 57.8496 53.7845 59.2096C51.7945 60.2496 49.7945 61.2896 47.8045 62.3296C43.5145 64.5696 39.0845 66.8796 34.7045 69.1096C31.2545 70.8796 27.7345 71.7596 24.2045 71.7596ZM27.4645 14.1396C25.9045 14.1396 24.3845 14.7696 23.2245 15.9096C21.0145 18.0796 18.8245 20.2696 16.6445 22.4696L15.0045 24.1196C14.1445 24.9796 13.2745 25.8396 12.4145 26.6896C10.3645 28.7196 8.24448 30.8196 6.23448 32.9596C-0.975521 40.7096 -1.18551 53.5396 5.76449 61.5496C8.24449 64.3996 11.0645 67.2796 14.8745 68.9896C21.4545 71.9396 28.0245 71.7696 34.4145 68.5196C38.7845 66.2896 43.2145 63.9796 47.5045 61.7396C49.4945 60.6996 51.4945 59.6596 53.4945 58.6196C55.8345 57.3996 57.0445 55.1396 56.7145 52.5796C56.4145 50.1596 54.5945 48.2596 52.0845 47.7196C51.7945 47.6596 51.4945 47.6296 51.1745 47.5996C51.0045 47.5896 50.8345 47.5696 50.6745 47.5496C50.5745 47.5396 50.4845 47.4796 50.4345 47.3996C50.3745 47.3196 50.3645 47.2096 50.3945 47.1096C50.4945 46.7596 50.7145 46.5596 50.9045 46.3996C50.9545 46.3596 50.9945 46.3196 51.0345 46.2796C54.6445 42.6596 58.2645 39.0496 61.8745 35.4296L70.7445 26.5596C73.1545 24.1396 73.2945 20.5796 71.0645 18.2796C69.9645 17.1396 68.4845 16.5096 66.9045 16.4896H66.8345C65.2845 16.4896 63.8245 17.0896 62.7145 18.1796C59.6745 21.1896 56.6545 24.2296 53.6345 27.2596L53.2945 27.5896C53.1945 27.6996 53.0945 27.8396 53.0045 27.9896C52.9445 28.0696 52.8945 28.1596 52.8445 28.2396C52.7745 28.3496 52.6445 28.3996 52.5045 28.3796C52.3745 28.3596 52.2645 28.2596 52.2345 28.1296C51.7045 26.0696 50.4045 24.4296 48.6645 23.6596C46.9445 22.8896 44.9745 23.0096 43.1245 23.9796C43.0245 24.0296 42.9145 24.0296 42.8145 23.9796C42.7145 23.9296 42.6445 23.8396 42.6245 23.7296C42.2345 21.5096 41.1545 20.0196 39.3345 19.1796C37.5145 18.3496 35.6845 18.4396 33.7245 19.4896C33.6245 19.5396 33.5145 19.5396 33.4245 19.4996C33.3245 19.4496 33.2545 19.3696 33.2345 19.2596C33.0445 18.3896 32.8045 17.4796 32.2745 16.6796C31.3145 15.2496 29.7845 14.3196 28.0745 14.1396C27.8745 14.1196 27.6745 14.1096 27.4745 14.1096M24.2145 69.3196C20.9545 69.3196 17.6945 68.4696 14.4445 66.7896C12.0545 65.5496 10.1945 63.6496 8.38448 61.8196L8.18448 61.6196C4.44448 57.8296 2.48448 53.0996 2.34448 47.5696C2.46448 41.9696 4.44448 37.1896 8.23448 33.3496C10.7445 30.8096 13.2645 28.2996 15.7945 25.7796L20.8345 20.7396C22.0345 19.5296 23.2345 18.3196 24.4545 17.1296C25.6845 15.9296 27.1545 15.5696 28.7245 16.0996C30.1745 16.5896 31.1045 17.6596 31.3945 19.2096C31.6645 20.5996 31.2145 21.8296 30.0445 22.9996C28.7445 24.2896 27.4645 25.5796 26.1645 26.8696L24.0445 28.9996C23.8245 29.2196 23.6245 29.4096 23.5945 29.6596C23.5345 30.0996 23.6645 30.3996 23.9945 30.5696C24.4245 30.7996 24.7845 30.7296 25.1845 30.3196C28.0245 27.4696 30.8745 24.6096 33.7245 21.7696C35.5145 19.9896 38.0145 19.8996 39.6745 21.5396C40.4845 22.3496 40.9145 23.3896 40.8745 24.4596C40.8345 25.5196 40.3445 26.5796 39.4745 27.4496C38.2545 28.6796 37.0245 29.8996 35.8045 31.1296L32.4145 34.5196C32.2145 34.7196 32.0445 34.8996 31.9245 35.0996C31.6845 35.4896 31.7345 35.8496 32.0645 36.1596C32.3745 36.4596 32.7445 36.4796 33.1545 36.2396C33.2845 36.1596 33.4145 36.0296 33.5345 35.8996L33.6645 35.7696C36.8445 32.5896 40.0145 29.4196 43.1945 26.2396C44.2345 25.1996 45.4545 24.7496 46.7645 24.9196C48.4045 25.1296 49.5445 26.0496 50.0645 27.5796C50.5945 29.1596 50.2645 30.6096 49.0945 31.7796C47.2645 33.6196 45.4245 35.4496 43.5945 37.2896L41.3345 39.5396C41.1245 39.7396 40.9245 39.9296 40.7345 40.1496C40.3945 40.5396 40.3945 41.0096 40.7345 41.3696C41.0445 41.6896 41.5845 41.7096 41.9545 41.3996C42.0945 41.2796 42.2245 41.1496 42.3445 41.0196L42.5345 40.8296L58.1045 25.2596C60.0345 23.3296 61.9645 21.3996 63.9045 19.4796C65.3645 18.0296 67.5745 17.8096 69.1545 18.9396C70.1745 19.6696 70.7845 20.7196 70.8745 21.8896C70.9745 23.1096 70.5045 24.2896 69.5645 25.2396C63.9045 30.8996 58.2445 36.5696 52.5845 42.2196L44.8645 49.9396C44.2045 50.5996 44.3145 50.9896 44.5045 51.2896C44.6145 51.4496 44.9445 51.9296 45.9245 51.4296C46.3345 51.2196 46.7445 51.0096 47.1545 50.7896C47.8245 50.4396 48.4845 50.0896 49.1645 49.7596C51.1545 48.7796 53.4645 49.5096 54.5345 51.4796C55.5845 53.3996 54.8945 55.7796 52.9645 56.8896C52.5945 57.1096 52.2045 57.2996 51.8245 57.4996L45.3845 60.8396C41.5445 62.8296 37.7145 64.8196 33.8745 66.8196C30.6745 68.4796 27.4445 69.3096 24.2145 69.3096M8.67448 61.1296L8.87448 61.3296C10.6445 63.1296 12.4745 64.9896 14.7645 66.1796C21.0245 69.4396 27.3545 69.4496 33.5645 66.2196C37.4045 64.2296 41.2345 62.2296 45.0745 60.2396L51.5145 56.8996C51.8845 56.7096 52.2645 56.5196 52.6245 56.3096C54.2345 55.3796 54.8045 53.3996 53.9345 51.8096C53.0445 50.1796 51.1245 49.5596 49.4645 50.3796C48.7945 50.7096 48.1345 51.0596 47.4645 51.4096C47.0545 51.6196 46.6445 51.8396 46.2345 52.0496C44.9045 52.7196 44.2245 52.1096 43.9345 51.6796C43.4645 50.9696 43.6145 50.2296 44.3745 49.4696L52.0945 41.7496C57.7545 36.0896 63.4145 30.4296 69.0745 24.7696C69.8745 23.9696 70.2645 22.9696 70.1845 21.9596C70.1045 20.9896 69.5945 20.1196 68.7445 19.5096C67.4145 18.5496 65.6245 18.7396 64.3745 19.9796C62.4345 21.8996 60.5145 23.8296 58.5745 25.7596L42.8345 41.5096C42.6845 41.6596 42.5345 41.8196 42.3745 41.9496C41.7245 42.4796 40.7845 42.4396 40.2245 41.8596C39.6345 41.2396 39.6345 40.3796 40.2045 39.7296C40.4045 39.4996 40.6245 39.2896 40.8445 39.0796L43.0945 36.8396C44.9245 35.0096 46.7645 33.1696 48.5945 31.3296C49.5845 30.3396 49.8545 29.1596 49.4045 27.8296C48.9645 26.5496 48.0445 25.7996 46.6645 25.6296C45.5545 25.4796 44.5645 25.8496 43.6645 26.7496C40.4845 29.9296 37.3145 33.1096 34.1345 36.2796L34.0145 36.3996C33.8545 36.5596 33.7045 36.7196 33.4945 36.8496C32.8345 37.2596 32.1145 37.1996 31.5845 36.6896C31.0245 36.1596 30.9345 35.4496 31.3345 34.7796C31.4945 34.5196 31.6945 34.2996 31.9245 34.0696L35.3145 30.6796C36.5445 29.4496 37.7645 28.2296 38.9845 27.0096C39.7345 26.2496 40.1545 25.3796 40.1945 24.4696C40.2245 23.5796 39.8845 22.7396 39.1945 22.0596C37.8145 20.6896 35.7145 20.7796 34.2145 22.2896C31.3645 25.1296 28.5145 27.9796 25.6745 30.8296C24.8945 31.6196 24.1545 31.4696 23.6645 31.1996C23.0845 30.8896 22.8245 30.3196 22.9145 29.6096C22.9745 29.1196 23.2845 28.8096 23.5645 28.5396L25.6845 26.4196C26.9745 25.1296 28.2645 23.8296 29.5645 22.5496C30.5745 21.5496 30.9445 20.5396 30.7245 19.3796C30.4745 18.0696 29.7245 17.1996 28.5045 16.7896C27.1845 16.3496 25.9845 16.6396 24.9345 17.6696C23.7145 18.8496 22.5245 20.0596 21.3245 21.2596L16.2845 26.2996C13.7545 28.8196 11.2345 31.3296 8.72448 33.8696C5.06448 37.5796 3.14448 42.1996 3.02448 47.6096C3.16448 52.9396 5.05448 57.5196 8.67448 61.1796"
        fill="currentColor"
      />
      <path
        d="M85.0839 23.9901C86.2139 23.9901 87.3539 24.0001 88.4839 23.9901C89.3339 23.9801 89.8539 23.4801 89.8539 22.7401C89.8539 22.0001 89.3139 21.4801 88.4839 21.4701C86.1939 21.4501 83.8939 21.4501 81.6039 21.4701C80.7639 21.4701 80.2539 22.0001 80.2539 22.7401C80.2539 23.4801 80.7639 23.9701 81.6139 23.9801C82.7739 23.9901 83.9339 23.9801 85.0939 23.9801"
        fill="currentColor"
      />
      <path
        d="M87.0841 24.34C86.7441 24.34 86.4141 24.34 86.0841 24.34H85.0841H84.0941C83.2641 24.34 82.4341 24.34 81.6041 24.34C80.5741 24.33 79.9141 23.7 79.9141 22.75C79.9141 21.79 80.5941 21.15 81.6041 21.14C83.8341 21.12 86.1541 21.12 88.4841 21.14C89.4741 21.15 90.1941 21.82 90.1941 22.75C90.1941 23.68 89.5241 24.33 88.4941 24.34C88.0241 24.34 87.5541 24.35 87.0941 24.35M85.0841 23.65H86.0841C86.8741 23.65 87.6741 23.65 88.4741 23.65C89.1241 23.64 89.5041 23.31 89.5041 22.74C89.5041 22.17 89.0941 21.82 88.4741 21.81C86.1441 21.79 83.8341 21.8 81.6041 21.81C80.9741 21.81 80.5941 22.16 80.5941 22.74C80.5941 23.52 81.2341 23.64 81.6141 23.64C82.4441 23.65 83.2641 23.64 84.0941 23.65H85.0941H85.0841Z"
        fill="currentColor"
      />
      <path
        d="M57.1448 14.1702C57.6748 14.1402 58.0848 13.8902 58.2848 13.3902C58.4948 12.8702 58.3848 12.3702 57.9848 11.9702C57.1848 11.1602 56.3848 10.3602 55.5848 9.56016C54.7848 8.76016 53.9848 7.95016 53.1748 7.16016C52.5648 6.56016 51.7548 6.49016 51.2448 6.97016C50.6648 7.51016 50.7048 8.28016 51.3648 8.95016C52.9248 10.5202 54.4948 12.0902 56.0648 13.6502C56.3648 13.9502 56.6748 14.2102 57.1448 14.1702Z"
        fill="currentColor"
      />
      <path
        d="M57.0542 14.5201C56.5242 14.5201 56.1542 14.2201 55.8242 13.8901L54.8842 12.9501C53.6342 11.7001 52.3742 10.4401 51.1242 9.1801C50.7142 8.7601 50.4942 8.2901 50.5042 7.8201C50.5042 7.4101 50.6942 7.03009 51.0142 6.72009C51.6542 6.11009 52.6842 6.2001 53.4142 6.9201C53.9842 7.4801 54.5442 8.0401 55.1042 8.6101L56.4242 9.9301C57.0242 10.5301 57.6342 11.1401 58.2242 11.7401C58.7242 12.2501 58.8542 12.8901 58.5942 13.5401C58.3442 14.1401 57.8442 14.4901 57.1642 14.5301C57.1242 14.5301 57.0842 14.5301 57.0442 14.5301M52.0542 7.0001C51.8442 7.0001 51.6442 7.07009 51.4842 7.22009C51.2942 7.41009 51.1942 7.6101 51.1842 7.8401C51.1842 8.1201 51.3242 8.4301 51.6042 8.7101C52.8542 9.9701 54.1042 11.2201 55.3642 12.4701L56.3042 13.4101C56.5842 13.6901 56.8042 13.8501 57.1142 13.8301H57.1242C57.5442 13.8101 57.8242 13.6201 57.9642 13.2601C58.1242 12.8701 58.0542 12.5201 57.7442 12.2101C57.1542 11.6101 56.5542 11.0001 55.9442 10.4101L54.6242 9.0901C54.0642 8.5301 53.5042 7.9701 52.9342 7.4101C52.6642 7.1401 52.3442 7.0001 52.0542 7.0001Z"
        fill="currentColor"
      />
      <path
        d="M82.2049 6.45996C81.8249 6.47996 81.4849 6.64996 81.2049 6.93996C79.6449 8.50996 78.0649 10.07 76.5049 11.65C75.8449 12.31 75.8149 13.09 76.3749 13.63C76.9549 14.19 77.6449 14.13 78.3349 13.44C79.9049 11.88 81.4749 10.3 83.0449 8.73996C83.4849 8.29996 83.6749 7.79996 83.4049 7.19996C83.1749 6.68996 82.7549 6.48996 82.2149 6.46996"
        fill="currentColor"
      />
      <path
        d="M77.195 14.3501C76.815 14.3501 76.455 14.1901 76.125 13.8701C75.805 13.5601 75.635 13.1801 75.625 12.7701C75.625 12.3001 75.835 11.8301 76.255 11.4101C77.155 10.5001 78.065 9.59012 78.965 8.69012C79.625 8.03012 80.285 7.37012 80.945 6.70012C81.305 6.35012 81.715 6.15012 82.175 6.12012H82.215C82.945 6.16012 83.445 6.47012 83.705 7.06012C84.005 7.74012 83.865 8.39012 83.275 8.98012L78.565 13.6901C78.115 14.1301 77.645 14.3601 77.195 14.3601M82.205 6.80012C81.925 6.82012 81.675 6.95012 81.435 7.18012C80.775 7.84012 80.115 8.51012 79.455 9.17012C78.545 10.0801 77.645 10.9801 76.745 11.8901C76.465 12.1801 76.315 12.4801 76.315 12.7701C76.315 13.0001 76.415 13.2001 76.605 13.3901C76.765 13.5501 77.255 14.0301 78.085 13.2001L82.795 8.50012C83.185 8.11012 83.275 7.76012 83.085 7.34012C82.935 6.99012 82.665 6.83012 82.205 6.81012"
        fill="currentColor"
      />
      <path
        d="M76.1738 32.8596C76.1738 33.2696 76.3638 33.5896 76.6438 33.8796C78.2338 35.4596 79.8138 37.0596 81.4138 38.6296C82.0338 39.2496 82.8038 39.2696 83.3338 38.7396C83.8638 38.2096 83.8238 37.4396 83.2138 36.8196C81.6338 35.2296 80.0338 33.6496 78.4638 32.0596C78.0138 31.5996 77.4938 31.4596 76.9138 31.6996C76.4138 31.8996 76.1738 32.3196 76.1838 32.8696"
        fill="currentColor"
      />
      <path
        d="M82.4737 39.4603C82.0237 39.4603 81.5638 39.2503 81.1738 38.8803C80.2838 38.0003 79.4037 37.1203 78.5237 36.2403C77.8237 35.5403 77.1137 34.8303 76.4137 34.1303C76.0337 33.7603 75.8438 33.3403 75.8438 32.8703C75.8438 32.1603 76.1737 31.6303 76.7937 31.3803C77.4837 31.1003 78.1537 31.2503 78.7137 31.8203C79.5637 32.6803 80.4237 33.5403 81.2837 34.4003C82.0137 35.1303 82.7437 35.8503 83.4637 36.5803C84.2037 37.3203 84.2537 38.3103 83.5938 38.9803C83.2838 39.2903 82.9037 39.4603 82.4937 39.4603H82.4837H82.4737ZM76.5237 32.8503C76.5237 33.1403 76.6437 33.3803 76.8937 33.6303C77.6037 34.3303 78.3037 35.0403 79.0137 35.7403C79.8937 36.6203 80.7737 37.5003 81.6637 38.3803C81.9137 38.6303 82.2037 38.7603 82.4737 38.7603C82.7037 38.7603 82.9138 38.6703 83.0938 38.4803C83.4938 38.0703 83.4437 37.5203 82.9737 37.0403C82.2437 36.3103 81.5237 35.5803 80.7937 34.8603C79.9337 34.0003 79.0737 33.1403 78.2237 32.2703C77.8537 31.9003 77.4837 31.8103 77.0437 31.9803C76.6937 32.1203 76.5237 32.4003 76.5237 32.8303"
        fill="currentColor"
      />
      <path
        d="M68.674 40.5697C68.674 39.4597 68.684 38.3497 68.674 37.2397C68.664 36.3397 68.164 35.8096 67.384 35.8296C66.634 35.8496 66.154 36.3596 66.154 37.2196C66.144 39.4896 66.144 41.7597 66.154 44.0197C66.154 44.8997 66.674 45.4597 67.444 45.4497C68.184 45.4297 68.674 44.8596 68.684 43.9696C68.684 42.8396 68.684 41.6997 68.684 40.5697"
        fill="currentColor"
      />
      <path
        d="M67.4145 45.8C66.9845 45.8 66.6045 45.65 66.3245 45.37C65.9945 45.05 65.8145 44.58 65.8145 44.03C65.8145 41.76 65.8145 39.49 65.8145 37.22C65.8145 36.2 66.4345 35.52 67.3745 35.5C67.8445 35.5 68.2145 35.63 68.5145 35.91C68.8345 36.22 69.0145 36.69 69.0145 37.24C69.0145 38.02 69.0145 38.79 69.0145 39.56V41.59C69.0145 42.39 69.0145 43.18 69.0145 43.98C69.0145 45.05 68.3745 45.78 67.4445 45.8H67.4145ZM67.4245 36.18H67.3944C66.6144 36.2 66.5045 36.84 66.4945 37.22C66.4845 39.49 66.4845 41.76 66.4945 44.02C66.4945 44.39 66.5945 44.68 66.7945 44.88C66.9545 45.03 67.1645 45.11 67.4045 45.11H67.4245C67.9745 45.1 68.3245 44.66 68.3245 43.97C68.3245 43.18 68.3245 42.38 68.3245 41.59V40.57V39.56C68.3245 38.79 68.3245 38.02 68.3245 37.25C68.3245 36.88 68.2145 36.58 68.0245 36.4C67.8745 36.25 67.6645 36.18 67.4145 36.18"
        fill="currentColor"
      />
      <path
        d="M68.3941 5.08048C68.3941 3.94048 68.3941 2.81049 68.3941 1.68049C68.3941 0.860489 67.9441 0.360483 67.2341 0.330483C66.4541 0.300483 65.8941 0.760483 65.8741 1.58048C65.8441 3.92048 65.8441 6.27049 65.8741 8.61049C65.8841 9.43049 66.4641 9.93048 67.2141 9.90048C67.9241 9.87048 68.3741 9.36049 68.3841 8.56049C68.3941 7.40049 68.3841 6.24048 68.3841 5.08048"
        fill="currentColor"
      />
      <path
        d="M67.1542 10.25C66.7142 10.25 66.3242 10.1 66.0242 9.82C65.7142 9.52 65.5342 9.1 65.5342 8.63C65.5042 6.21 65.5042 3.84 65.5342 1.59C65.5342 1.11 65.7042 0.699996 66.0142 0.409996C66.3242 0.119996 66.7742 0 67.2442 0C68.1542 0.04 68.7242 0.689995 68.7342 1.68999C68.7342 2.49999 68.7342 3.31 68.7342 4.12V6.25C68.7342 7.02 68.7342 7.8 68.7342 8.57C68.7242 9.56 68.1342 10.22 67.2342 10.26H67.1542V10.25ZM67.1342 0.669998C66.8542 0.669998 66.6342 0.749994 66.4742 0.899994C66.3042 1.05999 66.2142 1.3 66.2142 1.59C66.1842 3.84 66.1842 6.2 66.2142 8.61C66.2142 8.9 66.3142 9.15 66.4942 9.32C66.6642 9.49 66.9242 9.54 67.2042 9.56C67.7342 9.54 68.0442 9.17 68.0542 8.55C68.0642 7.78 68.0542 7.01 68.0542 6.23V5.07V4.1C68.0542 3.29 68.0542 2.49 68.0542 1.68C68.0542 1.24 67.9042 0.699998 67.2142 0.669998C67.1942 0.669998 67.1642 0.669998 67.1442 0.669998"
        fill="currentColor"
      />
    </svg>
  ),
  CameraIcon: (props) => (
    <svg
      width="65"
      height="50"
      viewBox="0 0 65 50"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.4394 41.6102C25.9194 41.6102 20.6094 36.3102 20.6094 29.8002C20.6094 23.2902 25.9194 17.9902 32.4394 17.9902C38.9594 17.9902 44.2694 23.2902 44.2694 29.8002C44.2694 36.3102 38.9594 41.6102 32.4394 41.6102ZM32.4394 19.0902C26.5294 19.0902 21.7194 23.8902 21.7194 29.7902C21.7194 35.6902 26.5294 40.4902 32.4394 40.4902C38.3494 40.4902 43.1594 35.6902 43.1594 29.7902C43.1594 23.8902 38.3494 19.0902 32.4394 19.0902Z"
        fill="currentColor"
      />
      <path
        d="M13.6909 19.9096H10.2109C9.06086 19.9096 8.13086 18.9696 8.13086 17.8196V16.4296C8.13086 15.2796 9.06086 14.3496 10.2109 14.3496H13.6909C14.8409 14.3496 15.7809 15.2796 15.7809 16.4296V17.8196C15.7809 18.9696 14.8409 19.9096 13.6909 19.9096ZM10.2109 15.4696C9.67086 15.4696 9.23086 15.9096 9.23086 16.4396V17.8296C9.23086 18.3696 9.67086 18.8096 10.2109 18.8096H13.6909C14.2309 18.8096 14.6709 18.3696 14.6709 17.8296V16.4396C14.6709 15.8996 14.2309 15.4696 13.6909 15.4696H10.2109Z"
        fill="currentColor"
      />
      <path
        d="M32.4399 38.3103C27.7399 38.3103 23.9199 34.4903 23.9199 29.8003C23.9199 25.1103 27.7399 21.2803 32.4399 21.2803C37.1399 21.2803 40.9699 25.1003 40.9699 29.8003C40.9699 34.5003 37.1499 38.3103 32.4399 38.3103ZM32.4399 22.3803C28.3499 22.3803 25.0299 25.7003 25.0299 29.7903C25.0299 33.8803 28.3599 37.1903 32.4399 37.1903C36.5199 37.1903 39.8599 33.8703 39.8599 29.7903C39.8599 25.7103 36.5299 22.3803 32.4399 22.3803Z"
        fill="currentColor"
      />
      <path
        d="M57.46 49.4798H7.43C3.33 49.4798 0 46.7398 0 43.3598V16.2098C0 12.8398 3.33 10.0898 7.43 10.0898H57.46C61.56 10.0898 64.89 12.8298 64.89 16.2098V43.3598C64.89 46.7298 61.56 49.4798 57.46 49.4798ZM7.43 11.2098C3.95 11.2098 1.11 13.4598 1.11 16.2198V43.3698C1.11 46.1298 3.94 48.3798 7.43 48.3798H57.46C60.94 48.3798 63.78 46.1298 63.78 43.3698V16.2198C63.78 13.4598 60.95 11.2098 57.46 11.2098H7.43Z"
        fill="currentColor"
      />
      <path
        d="M15.1794 11.2099H7.90937C7.59937 11.2099 7.35938 10.9599 7.35938 10.6599V6.21992C7.35938 5.90992 7.60937 5.66992 7.90937 5.66992H15.1794C15.4894 5.66992 15.7294 5.91992 15.7294 6.21992V10.6599C15.7294 10.9699 15.4794 11.2099 15.1794 11.2099ZM8.45938 10.0999H14.6194V6.76992H8.45938V10.0999Z"
        fill="currentColor"
      />
      <path
        d="M39.9691 11.21H24.9291C24.6191 11.21 24.3691 10.96 24.3691 10.66V5.21C24.3691 2.34 26.7091 0 29.5791 0H35.2991C38.1791 0 40.5191 2.34 40.5191 5.21V10.66C40.5191 10.97 40.2691 11.21 39.9691 11.21ZM25.4791 10.1H39.4191V5.2C39.4191 2.94 37.5791 1.1 35.3091 1.1H29.5891C27.3291 1.1 25.4891 2.94 25.4891 5.2V10.1H25.4791Z"
        fill="currentColor"
      />
      <path
        d="M37.1007 11.2098H27.7807C27.4707 11.2098 27.2207 10.9598 27.2207 10.6598V7.92981C27.2207 6.33981 28.7707 5.0498 30.6707 5.0498H34.2107C36.1107 5.0498 37.6507 6.33981 37.6507 7.92981V10.6598C37.6507 10.9698 37.4007 11.2098 37.1007 11.2098ZM28.3407 10.0998H36.5507V7.92981C36.5507 6.96981 35.4807 6.15981 34.2207 6.15981H30.6807C29.4107 6.15981 28.3407 6.96981 28.3407 7.92981V10.0998Z"
        fill="currentColor"
      />
      <path
        d="M55.6798 24.6397C52.7298 24.6397 50.3398 22.2497 50.3398 19.3097C50.3398 16.3697 52.7398 13.9697 55.6798 13.9697C58.6198 13.9697 61.0198 16.3697 61.0198 19.3097C61.0198 22.2497 58.6298 24.6397 55.6798 24.6397ZM55.6798 15.0797C53.3498 15.0797 51.4498 16.9797 51.4498 19.3097C51.4498 21.6397 53.3498 23.5297 55.6798 23.5297C58.0098 23.5297 59.9098 21.6397 59.9098 19.3097C59.9098 16.9797 58.0098 15.0797 55.6798 15.0797Z"
        fill="currentColor"
      />
      <path
        d="M60.0707 43.61H46.0207C45.7107 43.61 45.4707 43.36 45.4707 43.06C45.4707 42.76 45.7207 42.5 46.0207 42.5H60.0707C60.3807 42.5 60.6207 42.75 60.6207 43.06C60.6207 43.37 60.3707 43.61 60.0707 43.61Z"
        fill="currentColor"
      />
      <path
        d="M54.6505 46.7904H46.0305C45.7205 46.7904 45.4805 46.5404 45.4805 46.2404C45.4805 45.9404 45.7305 45.6904 46.0305 45.6904H54.6505C54.9605 45.6904 55.2005 45.9404 55.2005 46.2404C55.2005 46.5404 54.9505 46.7904 54.6505 46.7904Z"
        fill="currentColor"
      />
    </svg>
  ),
  PhotoBoothIcon: (props) => (
    <svg
      width="50"
      height="73"
      viewBox="0 0 50 73"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M38.0548 7.5625V8.5125H47.4748C48.5648 8.5125 50.0848 10.1225 49.9748 11.0725V66.4825C50.0448 67.4725 48.5548 68.9825 47.4048 68.9825H45.1347V70.8225H46.3648C46.4448 70.8225 46.7547 71.0625 46.7947 71.1525C46.9847 71.5525 46.8148 71.9325 46.3348 72.0525L3.98476 72.0825C3.37476 72.1125 3.01476 71.5925 3.24476 71.1325C3.27476 71.0725 3.63476 70.8125 3.69476 70.8125H4.92475V68.9725H2.42475C1.40475 68.9725 -0.095247 67.5025 0.004753 66.6025V10.7625C0.214753 9.5625 1.30475 8.6425 2.72475 8.5025H11.8948L12.0748 8.4025V7.5525H9.44476C8.95476 7.5525 7.85475 7.0425 7.47475 6.7625C4.75475 4.8225 5.79475 0.7425 9.33475 0.1125C19.8148 -0.0375 30.3647 -0.0375 40.8547 0.1125C44.1347 0.8025 45.2947 4.2825 43.0447 6.4125C42.5947 6.8425 41.3348 7.5525 40.6648 7.5525H38.0948L38.0548 7.5625ZM9.65476 1.3125C6.50476 1.9625 6.63476 5.9025 9.85476 6.3625H40.0948C43.4948 5.9925 43.5848 1.8225 40.2448 1.2925L9.64475 1.3125H9.65476ZM36.6448 7.5625H13.4748V8.5125L36.5747 8.4825L36.6448 7.5625ZM1.40476 46.7625H48.4448C48.5548 46.7025 48.5448 46.6325 48.5648 46.5425C48.6848 45.6825 48.4947 44.5125 48.4847 43.6225C48.3747 33.1625 48.4647 22.6925 48.4847 12.2125C48.4847 11.9325 48.5948 11.6525 48.5648 11.3225C48.4948 10.4525 47.9347 9.8125 46.8847 9.7125C32.1147 9.7725 17.3248 9.6125 2.57476 9.7925C2.12476 9.8425 1.40476 10.5425 1.40476 10.8825V46.7525V46.7625ZM48.5548 47.9625H1.40476V66.6125C1.40476 67.0325 2.35475 67.8525 2.92475 67.7825H46.9548C47.8647 67.7425 48.5148 67.0325 48.5348 66.2925C48.5948 64.2725 48.5348 62.2225 48.5348 60.2125C48.5348 56.5925 48.5248 52.8825 48.5348 49.2725C48.5348 48.8325 48.4448 48.3825 48.5348 47.9725L48.5548 47.9625ZM43.7148 68.9825H6.31475V70.8225H43.7148V68.9825Z"
        fill="currentColor"
      />
      <path
        d="M20.7341 60.5624C20.5041 60.5224 20.2541 60.1624 20.2441 59.9624V51.5424C20.2641 51.2824 20.5441 51.0324 20.8341 50.9724L44.7141 50.9424C45.1841 50.9824 45.5141 51.1124 45.5741 51.5424C45.3541 54.2324 45.8641 57.2524 45.5741 59.9024C45.5541 60.1124 45.3841 60.5624 45.0841 60.5624H40.5042V64.3324C40.5042 64.5224 40.0441 64.9524 39.8041 65.0024L26.4641 65.0624C25.9341 65.1124 25.3141 64.5524 25.3141 64.1424V60.5624H20.7341ZM44.1642 52.1424H21.6641V59.3624H25.3141V57.1424C24.9841 57.1624 24.5841 57.1324 24.4041 56.8724C24.2341 56.6324 24.2041 55.2724 24.2841 54.9724C24.3441 54.7524 24.6641 54.5324 24.9241 54.5024L40.7741 54.4824C41.1141 54.4824 41.4341 54.6424 41.5141 54.9224C41.6041 55.2324 41.5842 56.4324 41.4742 56.7324C41.3342 57.1124 40.9242 57.1724 40.5042 57.1424V59.3624H44.1541V52.1424H44.1642ZM39.0941 55.6924H26.7241V63.8624H39.0941V55.6924Z"
        fill="currentColor"
      />
      <path
        d="M7.27437 52.8521C9.47437 52.9421 11.9344 52.6721 14.1144 52.8321C15.0844 52.9021 15.6344 53.4521 15.7144 54.2521C15.8144 55.2621 15.5144 56.1721 14.1844 56.3121C12.0444 56.1921 9.66437 56.4721 7.55437 56.3121C6.75437 56.2521 6.05436 55.8521 5.95436 55.1421C5.82436 54.1721 5.92437 53.0521 7.27437 52.8521ZM14.2144 54.1121C13.5344 54.0521 12.8544 54.0321 12.1744 54.0421C11.0844 54.0421 9.99437 54.1121 8.90437 54.1121C8.63437 54.1121 7.50437 53.9121 7.38437 54.2221C7.32437 54.3621 7.33437 54.9821 7.47437 55.0721L14.0344 55.1321C14.4344 55.0721 14.2944 54.3721 14.2144 54.1221V54.1121Z"
        fill="currentColor"
      />
      <path
        d="M41.3346 39.5323H8.63461C7.30461 39.5323 6.22461 38.4523 6.22461 37.1223V16.2323C6.22461 14.9023 7.30461 13.8223 8.63461 13.8223H41.3346C42.6646 13.8223 43.7446 14.9023 43.7446 16.2323V37.1223C43.7446 38.4523 42.6646 39.5323 41.3346 39.5323ZM8.63461 15.1523C8.04461 15.1523 7.55461 15.6323 7.55461 16.2323V37.1223C7.55461 37.7123 8.03461 38.2023 8.63461 38.2023H41.3346C41.9246 38.2023 42.4146 37.7223 42.4146 37.1223V16.2323C42.4146 15.6423 41.9346 15.1523 41.3346 15.1523H8.63461Z"
        fill="currentColor"
      />
    </svg>
  ),
  PictureIcon: (props) => (
    <svg
      width="63"
      height="41"
      viewBox="0 0 63 41"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M61.7839 40.61H0.533905C0.243905 40.61 0.00390625 40.37 0.00390625 40.08V0.530003C0.00390625 0.240003 0.243905 0 0.533905 0H61.7839C62.0739 0 62.3139 0.240003 62.3139 0.530003V40.08C62.3139 40.37 62.0739 40.61 61.7839 40.61ZM1.0639 39.54H61.2439V1.06H1.0639V39.54Z"
        fill="currentColor"
      />
      <path
        d="M23.1137 40.6099C22.9737 40.6099 22.8437 40.5599 22.7337 40.4499C22.5237 40.2399 22.5237 39.8999 22.7337 39.6999L46.7737 15.6799C46.9737 15.4799 47.2937 15.4699 47.5037 15.6599L62.1237 28.8399C62.3437 29.0399 62.3637 29.3699 62.1637 29.5899C61.9637 29.8099 61.6337 29.8299 61.4137 29.6299L47.1737 16.7899L23.4837 40.4499C23.3837 40.5499 23.2437 40.6099 23.1037 40.6099H23.1137Z"
        fill="currentColor"
      />
      <path
        d="M0.533778 40.6099C0.393778 40.6099 0.253773 40.5599 0.153773 40.4499C-0.0562271 40.2399 -0.0462271 39.8999 0.153773 39.6999L20.5538 19.6799C20.7538 19.4799 21.0738 19.4799 21.2838 19.6599L32.9538 30.1899C33.1738 30.3899 33.1938 30.7199 32.9938 30.9399C32.7938 31.1599 32.4638 31.1799 32.2438 30.9799L20.9438 20.7799L0.893794 40.4499C0.793794 40.5499 0.653798 40.5999 0.523798 40.5999L0.533778 40.6099Z"
        fill="currentColor"
      />
      <path
        d="M32.3143 18.6996C28.6443 18.6996 25.6543 15.7096 25.6543 12.0396C25.6543 8.36965 28.6443 5.38965 32.3143 5.38965C35.9843 5.38965 38.9743 8.36965 38.9743 12.0396C38.9743 15.7096 35.9843 18.6996 32.3143 18.6996ZM32.3143 6.45965C29.2243 6.45965 26.7143 8.95965 26.7143 12.0396C26.7143 15.1196 29.2243 17.6296 32.3143 17.6296C35.4043 17.6296 37.9143 15.1196 37.9143 12.0396C37.9143 8.95965 35.4043 6.45965 32.3143 6.45965Z"
        fill="currentColor"
      />
      <path
        d="M32.3132 6.4602C32.0232 6.4602 31.7832 6.22019 31.7832 5.93019V2.9802C31.7832 2.6902 32.0232 2.4502 32.3132 2.4502C32.6032 2.4502 32.8432 2.6902 32.8432 2.9802V5.93019C32.8432 6.22019 32.6032 6.4602 32.3132 6.4602Z"
        fill="currentColor"
      />
      <path
        d="M35.3731 7.27996C35.2831 7.27996 35.1931 7.25996 35.1031 7.20996C34.8431 7.05996 34.7631 6.73996 34.9131 6.47996L36.3831 3.92996C36.5331 3.67996 36.8531 3.58996 37.1131 3.73996C37.3631 3.88996 37.4531 4.20996 37.3031 4.46996L35.8331 7.01996C35.7331 7.18996 35.5531 7.28996 35.3731 7.28996V7.27996Z"
        fill="currentColor"
      />
      <path
        d="M37.6228 9.52015C37.4428 9.52015 37.2628 9.42015 37.1628 9.25015C37.0128 9.00015 37.1028 8.67015 37.3528 8.52015L39.9028 7.05015C40.1528 6.90015 40.4828 6.99015 40.6328 7.25015C40.7828 7.51015 40.6928 7.83015 40.4328 7.98015L37.8828 9.45015C37.8028 9.50015 37.7128 9.52015 37.6128 9.52015H37.6228Z"
        fill="currentColor"
      />
      <path
        d="M41.3941 12.5795H38.4441C38.1541 12.5795 37.9141 12.3395 37.9141 12.0495C37.9141 11.7595 38.1541 11.5195 38.4441 11.5195H41.3941C41.6841 11.5195 41.9241 11.7595 41.9241 12.0495C41.9241 12.3395 41.6841 12.5795 41.3941 12.5795Z"
        fill="currentColor"
      />
      <path
        d="M40.1728 17.1104C40.0828 17.1104 39.9928 17.0904 39.9028 17.0404L37.3528 15.5704C37.1028 15.4204 37.0128 15.1004 37.1628 14.8404C37.3128 14.5804 37.6328 14.5004 37.8928 14.6404L40.4428 16.1104C40.7028 16.2604 40.7828 16.5804 40.6428 16.8404C40.5428 17.0104 40.3628 17.1104 40.1828 17.1104H40.1728Z"
        fill="currentColor"
      />
      <path
        d="M36.8545 20.4302C36.6745 20.4302 36.4945 20.3302 36.3945 20.1602L34.9245 17.6102C34.7745 17.3602 34.8645 17.0302 35.1145 16.8802C35.3745 16.7302 35.6945 16.8202 35.8445 17.0802L37.3145 19.6302C37.4645 19.8802 37.3745 20.2102 37.1245 20.3602C37.0445 20.4102 36.9445 20.4302 36.8545 20.4302Z"
        fill="currentColor"
      />
      <path
        d="M32.3132 21.6496C32.0232 21.6496 31.7832 21.4096 31.7832 21.1196V18.1696C31.7832 17.8796 32.0232 17.6396 32.3132 17.6396C32.6032 17.6396 32.8432 17.8796 32.8432 18.1696V21.1196C32.8432 21.4096 32.6032 21.6496 32.3132 21.6496Z"
        fill="currentColor"
      />
      <path
        d="M27.7745 20.4305C27.6845 20.4305 27.5945 20.4105 27.5045 20.3605C27.2445 20.2105 27.1645 19.8905 27.3045 19.6305L28.7745 17.0805C28.9245 16.8305 29.2445 16.7405 29.5045 16.8805C29.7545 17.0305 29.8445 17.3505 29.7045 17.6105L28.2345 20.1605C28.1345 20.3305 27.9545 20.4305 27.7745 20.4305Z"
        fill="currentColor"
      />
      <path
        d="M24.4545 17.11C24.2745 17.11 24.0945 17.01 23.9945 16.84C23.8445 16.59 23.9345 16.26 24.1945 16.11L26.7445 14.64C27.0045 14.49 27.3245 14.58 27.4745 14.84C27.6245 15.1 27.5345 15.42 27.2745 15.57L24.7245 17.04C24.6445 17.09 24.5445 17.11 24.4545 17.11Z"
        fill="currentColor"
      />
      <path
        d="M26.1831 12.5795H23.2331C22.9431 12.5795 22.7031 12.3395 22.7031 12.0495C22.7031 11.7595 22.9431 11.5195 23.2331 11.5195H26.1831C26.4731 11.5195 26.7131 11.7595 26.7131 12.0495C26.7131 12.3395 26.4731 12.5795 26.1831 12.5795Z"
        fill="currentColor"
      />
      <path
        d="M27.004 9.51961C26.914 9.51961 26.824 9.49961 26.734 9.44961L24.184 7.97961C23.934 7.82961 23.844 7.50961 23.984 7.24961C24.134 6.98961 24.454 6.90961 24.714 7.04961L27.264 8.51961C27.524 8.66961 27.604 8.98961 27.464 9.24961C27.364 9.41961 27.184 9.51961 27.004 9.51961Z"
        fill="currentColor"
      />
      <path
        d="M29.2432 7.28019C29.0632 7.28019 28.8832 7.18019 28.7832 7.01019L27.3132 4.46019C27.1632 4.20019 27.2532 3.88019 27.5032 3.73019C27.7532 3.58019 28.0832 3.67019 28.2332 3.92019L29.7032 6.47019C29.8532 6.73019 29.7632 7.05019 29.5132 7.20019C29.4332 7.25019 29.3332 7.27019 29.2432 7.27019V7.28019Z"
        fill="currentColor"
      />
      <path
        d="M8.50344 17.1697C8.31344 17.1697 8.13344 17.0697 8.03344 16.8997C8.03344 16.8797 6.92345 14.9697 4.83345 14.4497C4.54345 14.3797 4.37344 14.0897 4.44344 13.7997C4.51344 13.5197 4.80343 13.3397 5.09343 13.4097C7.64343 14.0497 8.91346 16.2797 8.96346 16.3797C9.10346 16.6397 9.01344 16.9597 8.75344 17.0997C8.67344 17.1497 8.58346 17.1697 8.49346 17.1697H8.50344Z"
        fill="currentColor"
      />
      <path
        d="M8.50446 17.1702C8.41446 17.1702 8.32448 17.1502 8.24448 17.1002C7.98448 16.9602 7.89446 16.6302 8.03446 16.3802C8.08446 16.2902 9.35445 14.0502 11.9045 13.4102C12.1945 13.3402 12.4745 13.5102 12.5545 13.8002C12.6245 14.0902 12.4545 14.3802 12.1645 14.4502C10.0745 14.9702 8.97448 16.8802 8.96448 16.9002C8.86448 17.0702 8.68448 17.1702 8.49448 17.1702H8.50446Z"
        fill="currentColor"
      />
      <path
        d="M33.023 25.6605C32.833 25.6605 32.653 25.5605 32.553 25.3905C32.543 25.3705 31.443 23.4705 29.353 22.9405C29.063 22.8705 28.893 22.5805 28.963 22.2905C29.033 22.0005 29.323 21.8305 29.613 21.9005C32.163 22.5405 33.433 24.7705 33.483 24.8605C33.623 25.1205 33.533 25.4405 33.273 25.5805C33.193 25.6305 33.103 25.6505 33.013 25.6505L33.023 25.6605Z"
        fill="currentColor"
      />
      <path
        d="M33.024 25.6602C32.934 25.6602 32.844 25.6402 32.764 25.5902C32.504 25.4502 32.414 25.1202 32.554 24.8702C32.604 24.7802 33.874 22.5402 36.424 21.9102C36.714 21.8402 36.994 22.0102 37.074 22.3002C37.144 22.5902 36.974 22.8702 36.684 22.9502C34.574 23.4802 33.494 25.3802 33.484 25.4002C33.384 25.5702 33.204 25.6702 33.014 25.6702L33.024 25.6602Z"
        fill="currentColor"
      />
      <path
        d="M53.523 12.3897C53.333 12.3897 53.153 12.2897 53.053 12.1197C53.053 12.0997 51.943 10.1897 49.853 9.66973C49.563 9.59973 49.393 9.30973 49.463 9.02973C49.533 8.73973 49.823 8.56973 50.103 8.63973C52.653 9.26973 53.923 11.5097 53.983 11.5997C54.123 11.8597 54.033 12.1797 53.773 12.3197C53.693 12.3697 53.603 12.3897 53.513 12.3897H53.523Z"
        fill="currentColor"
      />
      <path
        d="M53.524 12.3897C53.434 12.3897 53.344 12.3697 53.264 12.3197C53.004 12.1797 52.914 11.8497 53.054 11.5997C53.104 11.5097 54.374 9.26973 56.934 8.63973C57.224 8.56973 57.504 8.73973 57.584 9.02973C57.654 9.31973 57.484 9.59973 57.194 9.66973C55.084 10.1897 54.004 12.0997 53.994 12.1197C53.894 12.2897 53.714 12.3897 53.524 12.3897Z"
        fill="currentColor"
      />
    </svg>
  ),
  PhotoSheetIcon: (props) => (
    <svg
      width="68"
      height="27"
      viewBox="0 0 68 27"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M67.74 26.31V0H0V26.31H67.74ZM1.57996 24.57V1.73H18.91V24.57H1.57996ZM21.65 24.57V1.73H38.98V24.57H21.65ZM41.71 24.57V1.73H59.04V24.57H41.71Z"
        fill="currentColor"
      />
    </svg>
  ),
  Next2Icon: (props) => (
    <svg
      width="33"
      height="22"
      viewBox="0 0 33 22"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.8578 21.25V0L32.5078 10.63L17.8578 21.25Z"
        fill="currentColor"
      />
      <path
        d="M-0.00156403 21.25V0L14.6484 10.63L-0.00156403 21.25Z"
        fill="currentColor"
      />
    </svg>
  ),
  DotIcon: (props) => (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.31 1.12C24.68 1.12 31.5 7.93 31.5 16.31C31.5 24.69 24.69 31.5 16.31 31.5C7.93 31.5 1.12 24.69 1.12 16.31C1.12 7.93 7.93 1.12 16.31 1.12ZM16.31 0C7.32 0 0 7.32 0 16.31C0 25.3 7.32 32.62 16.31 32.62C25.3 32.62 32.62 25.3 32.62 16.31C32.62 7.32 25.3 0 16.31 0Z"
        fill="transparent"
      />
      <path
        d="M16.3097 26.4299C10.7297 26.4299 6.17969 21.8899 6.17969 16.2999C6.17969 10.7099 10.7197 6.16992 16.3097 6.16992C21.8997 6.16992 26.4397 10.7099 26.4397 16.2999C26.4397 21.8899 21.8997 26.4299 16.3097 26.4299Z"
        fill="currentColor"
      />
    </svg>
  ),
  DotActiveIcon: (props) => (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.31 1.12C24.68 1.12 31.5 7.93 31.5 16.31C31.5 24.69 24.69 31.5 16.31 31.5C7.93 31.5 1.12 24.69 1.12 16.31C1.12 7.93 7.93 1.12 16.31 1.12ZM16.31 0C7.32 0 0 7.32 0 16.31C0 25.3 7.32 32.62 16.31 32.62C25.3 32.62 32.62 25.3 32.62 16.31C32.62 7.32 25.3 0 16.31 0Z"
        fill="currentColor"
      />
      <path
        d="M16.3097 26.4299C10.7297 26.4299 6.17969 21.8899 6.17969 16.2999C6.17969 10.7099 10.7197 6.16992 16.3097 6.16992C21.8997 6.16992 26.4397 10.7099 26.4397 16.2999C26.4397 21.8899 21.8997 26.4299 16.3097 26.4299Z"
        fill="currentColor"
      />
    </svg>
  ),
  MoneyBigIcon: (props) => (
    <svg
      width="323"
      height="400"
      viewBox="0 0 323 400"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M263.781 146.866H302.564C304.073 146.866 305.389 150.345 305.605 151.817C307.484 164.785 304.133 181.656 305.497 195.081C314.403 198.694 320.137 205.329 322.279 214.149V357.726C319.718 368.642 311.003 376.637 298.985 378.287L121.191 378.31C74.1005 426.447 -12.5401 388.29 1.52492 323.493C4.86462 308.083 14.8598 298.538 23.8255 286.428L24.1726 167.706C25.8365 159.321 39.2551 146.855 48.3525 146.855H79.9779V0H261.973L263.769 1.6726V146.866H263.781ZM253.044 11.1284H90.7391V193.587H126.542C95.3955 166.725 97.3227 118.108 132.587 95.2047C183.52 62.1094 250.518 104.56 236.716 161.128C233.424 174.62 226.182 183.117 217.229 193.587H251.236L253.032 11.1284H253.044ZM170.485 93.7216C124.435 94.8032 98.9387 144.937 127.236 179.036C130.468 182.938 140.021 191.045 144.773 192.729C148.962 194.212 190.631 194.39 196.077 193.342C208.957 190.866 223.274 170.472 226.218 159.143C234.813 126.126 207.174 92.8742 170.485 93.7216ZM80.0018 156.879H50.7585C50.2318 156.879 43.6362 159.767 42.5948 160.392C31.7378 167.015 31.7378 183.451 42.5948 190.075C43.6362 190.71 50.2318 193.587 50.7585 193.587H80.0018V156.868V156.879ZM294.808 156.879H263.781V193.598H294.808V156.879ZM311.518 249.218V214.171C311.518 210.157 301.367 203.021 296.603 203.601L51.9196 203.645L34.6585 198.048V281.488C96.0898 250.634 160.442 311.026 127.739 368.274H298.985C302.277 368.274 311.518 360.859 311.518 357.703V322.657H281.09C277.128 322.657 266.749 317.226 263.398 314.673C241.373 297.924 245.418 263.603 271.322 252.363C272.687 251.772 280.348 249.229 281.09 249.229H311.518V249.218ZM311.518 259.231H282.275C281.724 259.231 276.098 261.774 274.889 262.365C255.641 271.787 254.719 298.203 273.417 308.651C274.889 309.476 281.293 312.632 282.275 312.632H311.518V259.231ZM59.4489 284.019C-9.15253 291.791 -2.77239 397.076 76.8656 389.271C146.556 382.435 139.901 274.898 59.4489 284.019Z"
        fill="currentColor"
      />
      <path
        d="M213.661 24.4756C211.327 39.8635 222.698 49.0517 238.726 47.8363C237.446 58.541 240.462 72.5574 238.655 82.8272C237.194 91.1233 228.312 91.101 226.864 82.8272C226.134 78.7126 227.63 57.8942 226.672 56.8572C214.259 55.2181 205.701 45.6062 202.768 34.645L139.733 34.5447C138.835 45.3943 127.439 55.9763 115.864 56.7903C114.775 62.4883 117.755 84.3771 114.332 87.622C112.512 89.3392 108 89.1719 106.24 87.3544C103.08 84.0872 106.216 54.326 105.067 47.8363C120.401 48.5945 131.916 39.2726 130.132 24.4756H213.673H213.661Z"
        fill="currentColor"
      />
      <path
        d="M170.402 49.1414C182.456 47.2681 184.048 65.8452 172.293 66.425C161.388 66.9603 158.312 51.0148 170.402 49.1414Z"
        fill="currentColor"
      />
      <path
        d="M74.0402 298.17L74.1839 304.704L89.5177 310.96L84.0952 318.264C76.937 313.625 60.5378 310.469 58.7303 321.263C56.851 332.469 75.6203 331.644 82.7067 335.146C93.037 340.242 93.8749 357.213 85.388 363.825C79.4508 368.453 71.6581 365.397 74.0402 374.942H64.476L64.3563 368.364C55.1751 366.691 38.0696 360.38 52.9726 352.764C59.6759 362.275 84.0832 362.197 80.971 347.947C79.1036 339.416 59.7118 341.725 53.1043 336.027C46.9396 330.697 47.4902 316.044 53.0684 310.358C58.1796 305.15 66.8341 307.971 64.464 298.17H74.0282H74.0402Z"
        fill="currentColor"
      />
      <path
        d="M176.675 107.916L177.8 115.209C183.019 115.8 188.118 117.428 192.14 120.706L186.837 127.82C178.015 121.263 157.965 121.509 162.598 136.072C164.968 143.509 186.382 140.052 192.427 151.638C198.664 163.603 190.728 176.705 176.806 178.165L176.663 184.7H167.098L166.955 178.165C163.555 177.954 148.568 172.278 149.287 168.71L154.601 162.432C156.828 162.432 158.659 165.587 160.73 166.736C166.751 170.048 180.768 171.007 183.282 163.625C187.986 149.776 170.666 151.783 162.059 148.817C145.66 143.163 149.263 116.803 167.003 115.621L167.11 107.938H176.675V107.916Z"
        fill="currentColor"
      />
      <path
        d="M280.803 280.652C288.045 273.471 300.027 282.681 293.707 291.022C287.219 299.586 273.441 287.967 280.803 280.652Z"
        fill="currentColor"
      />
    </svg>
  ),
  QRCodeBigIcon: (props) => (
    <svg
      width="321"
      height="321"
      viewBox="0 0 321 321"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M187.516 296.761H205.719V278.557H187.516V296.761Z"
        fill="currentColor"
      />
      <path
        d="M169.313 278.558H187.516V260.354H169.313V278.558Z"
        fill="currentColor"
      />
      <path
        d="M151.11 296.761H169.312V278.557H151.11V296.761Z"
        fill="currentColor"
      />
      <path
        d="M114.707 296.761H132.91V278.557H114.707V296.761Z"
        fill="currentColor"
      />
      <path
        d="M187.516 278.558H205.719V260.354H187.516V278.558Z"
        fill="currentColor"
      />
      <path
        d="M251.246 269.462H269.449V251.258H251.246V269.462Z"
        fill="currentColor"
      />
      <path
        d="M132.907 278.558H151.109V260.354H132.907V278.558Z"
        fill="currentColor"
      />
      <path
        d="M114.707 278.558H132.91V260.354H114.707V278.558Z"
        fill="currentColor"
      />
      <path
        d="M187.516 260.34H205.719V242.136H187.516V260.34Z"
        fill="currentColor"
      />
      <path
        d="M169.313 260.34H187.516V242.136H169.313V260.34Z"
        fill="currentColor"
      />
      <path
        d="M151.11 260.34H169.312V242.136H151.11V260.34Z"
        fill="currentColor"
      />
      <path
        d="M114.707 260.34H132.91V242.136H114.707V260.34Z"
        fill="currentColor"
      />
      <path
        d="M242.14 296.761H296.762V223.933H223.938V296.761H242.14ZM242.14 260.354V242.15H278.546V278.557H242.14V260.354Z"
        fill="currentColor"
      />
      <path
        d="M151.11 242.15H169.312V223.947H151.11V242.15Z"
        fill="currentColor"
      />
      <path
        d="M132.907 242.15H151.109V223.947H132.907V242.15Z"
        fill="currentColor"
      />
      <path
        d="M41.8668 296.761H60.0696H78.2723H96.4751V223.933H23.6641V296.761H41.8668ZM41.8668 260.354V242.15H78.2723V278.557H41.8668V260.354Z"
        fill="currentColor"
      />
      <path
        d="M69.1793 251.245H50.9766V269.449H69.1793V251.245Z"
        fill="currentColor"
      />
      <path
        d="M187.516 223.946H205.719V205.743H187.516V223.946Z"
        fill="currentColor"
      />
      <path
        d="M114.707 223.946H132.91V205.743H114.707V223.946Z"
        fill="currentColor"
      />
      <path
        d="M278.543 205.729H296.746V187.526H278.543V205.729Z"
        fill="currentColor"
      />
      <path
        d="M260.34 205.729H278.543V187.526H260.34V205.729Z"
        fill="currentColor"
      />
      <path
        d="M242.125 205.729H260.328V187.526H242.125V205.729Z"
        fill="currentColor"
      />
      <path
        d="M205.735 205.729H223.938V187.526H205.735V205.729Z"
        fill="currentColor"
      />
      <path
        d="M151.11 205.729H169.312V187.526H151.11V205.729Z"
        fill="currentColor"
      />
      <path
        d="M132.907 205.729H151.109V187.526H132.907V205.729Z"
        fill="currentColor"
      />
      <path
        d="M96.4887 205.729H114.691V187.526H96.4887V205.729Z"
        fill="currentColor"
      />
      <path
        d="M78.2855 205.729H96.4883V187.526H78.2855V205.729Z"
        fill="currentColor"
      />
      <path
        d="M41.8793 205.729H60.082V187.526H41.8793V205.729Z"
        fill="currentColor"
      />
      <path
        d="M23.6762 205.729H41.8789V187.526H23.6762L23.6762 205.729Z"
        fill="currentColor"
      />
      <path
        d="M260.34 187.525H278.543V169.322H260.34V187.525Z"
        fill="currentColor"
      />
      <path
        d="M223.938 187.525H242.141V169.322H223.938V187.525Z"
        fill="currentColor"
      />
      <path
        d="M205.735 187.525H223.938V169.322H205.735V187.525Z"
        fill="currentColor"
      />
      <path
        d="M187.516 187.525H205.719V169.322H187.516V187.525Z"
        fill="currentColor"
      />
      <path
        d="M151.11 187.525H169.312V169.322H151.11V187.525Z"
        fill="currentColor"
      />
      <path
        d="M114.707 187.525H132.91V169.322H114.707V187.525Z"
        fill="currentColor"
      />
      <path
        d="M60.0824 187.525H78.2852V169.322H60.0824V187.525Z"
        fill="currentColor"
      />
      <path
        d="M278.543 169.309H296.746V151.105H278.543V169.309Z"
        fill="currentColor"
      />
      <path
        d="M260.34 169.309H278.543V151.105H260.34V169.309Z"
        fill="currentColor"
      />
      <path
        d="M242.137 169.309H260.34V151.105H242.137V169.309Z"
        fill="currentColor"
      />
      <path
        d="M187.516 169.309H205.719V151.105H187.516V169.309Z"
        fill="currentColor"
      />
      <path
        d="M169.313 169.309H187.516V151.105H169.313V169.309Z"
        fill="currentColor"
      />
      <path
        d="M132.907 169.309H151.109V151.105H132.907V169.309Z"
        fill="currentColor"
      />
      <path
        d="M114.707 169.309H132.91V151.105H114.707V169.309Z"
        fill="currentColor"
      />
      <path
        d="M96.4887 169.309H114.691V151.105H96.4887V169.309Z"
        fill="currentColor"
      />
      <path
        d="M23.6762 169.309H41.8789V151.105H23.6762L23.6762 169.309Z"
        fill="currentColor"
      />
      <path
        d="M278.543 151.118H296.746V132.915H278.543V151.118Z"
        fill="currentColor"
      />
      <path
        d="M242.137 151.118H260.34V132.915H242.137V151.118Z"
        fill="currentColor"
      />
      <path
        d="M223.938 151.118H242.141V132.915H223.938V151.118Z"
        fill="currentColor"
      />
      <path
        d="M151.11 151.118H169.312V132.915H151.11V151.118Z"
        fill="currentColor"
      />
      <path
        d="M169.313 132.915H187.516V114.712H169.313V132.915Z"
        fill="currentColor"
      />
      <path
        d="M132.907 151.118H151.109V132.915H132.907V151.118Z"
        fill="currentColor"
      />
      <path
        d="M96.4887 151.118H114.691V132.915H96.4887V151.118Z"
        fill="currentColor"
      />
      <path
        d="M78.2855 151.118H96.4883V132.915H78.2855V151.118Z"
        fill="currentColor"
      />
      <path
        d="M60.0824 151.118H78.2852V132.915H60.0824V151.118Z"
        fill="currentColor"
      />
      <path
        d="M60.0824 169.309H78.2852V151.105H60.0824V169.309Z"
        fill="currentColor"
      />
      <path
        d="M41.8793 151.118H60.082V132.915H41.8793V151.118Z"
        fill="currentColor"
      />
      <path
        d="M23.6762 151.118H41.8789V132.915H23.6762L23.6762 151.118Z"
        fill="currentColor"
      />
      <path
        d="M260.34 132.915H278.543V114.712H260.34V132.915Z"
        fill="currentColor"
      />
      <path
        d="M242.137 132.915H260.34V114.712H242.137V132.915Z"
        fill="currentColor"
      />
      <path
        d="M205.735 132.915H223.938V114.712H205.735V132.915Z"
        fill="currentColor"
      />
      <path
        d="M151.11 132.915H169.312V114.712H151.11V132.915Z"
        fill="currentColor"
      />
      <path
        d="M151.11 114.697H169.312V96.4938H151.11V114.697Z"
        fill="currentColor"
      />
      <path
        d="M114.707 132.915H132.91V114.712H114.707V132.915Z"
        fill="currentColor"
      />
      <path
        d="M96.4887 132.915H114.691V114.712H96.4887V132.915Z"
        fill="currentColor"
      />
      <path
        d="M60.0824 132.915H78.2852V114.712H60.0824V132.915Z"
        fill="currentColor"
      />
      <path
        d="M23.6762 132.915H41.8789V114.712H23.6762L23.6762 132.915Z"
        fill="currentColor"
      />
      <path
        d="M187.516 114.697H205.719V96.4938H187.516V114.697Z"
        fill="currentColor"
      />
      <path
        d="M96.4887 114.697H114.691V96.4938H96.4887V114.697Z"
        fill="currentColor"
      />
      <path
        d="M78.2855 114.697H96.4883V96.4938H78.2855V114.697Z"
        fill="currentColor"
      />
      <path
        d="M41.8793 114.697H60.082V96.4938H41.8793V114.697Z"
        fill="currentColor"
      />
      <path
        d="M23.6762 114.697H41.8789V96.4938H23.6762L23.6762 114.697Z"
        fill="currentColor"
      />
      <path
        d="M169.313 96.4941H187.516V78.2906H169.313V96.4941Z"
        fill="currentColor"
      />
      <path
        d="M187.516 96.4941H205.719V78.2906H187.516V96.4941Z"
        fill="currentColor"
      />
      <path
        d="M151.11 96.4941H169.312V78.2906H151.11V96.4941Z"
        fill="currentColor"
      />
      <path
        d="M114.707 96.4941H132.91V78.2906H114.707V96.4941Z"
        fill="currentColor"
      />
      <path
        d="M96.4887 96.4941H114.691V78.2906H96.4887V96.4941Z"
        fill="currentColor"
      />
      <path
        d="M60.0824 96.4941H78.2852V78.2906H60.0824V96.4941Z"
        fill="currentColor"
      />
      <path
        d="M151.11 78.2764H169.312V60.0728H151.11V78.2764Z"
        fill="currentColor"
      />
      <path
        d="M132.907 78.2764H151.109V60.0728H132.907V78.2764Z"
        fill="currentColor"
      />
      <path
        d="M96.4887 78.2764H114.691V60.0728H96.4887V78.2764Z"
        fill="currentColor"
      />
      <path
        d="M78.2855 78.2764H96.4883V60.0728H78.2855V78.2764Z"
        fill="currentColor"
      />
      <path
        d="M60.0824 78.2764H78.2852V60.0728H60.0824V78.2764Z"
        fill="currentColor"
      />
      <path
        d="M23.6762 78.2764H41.8789V60.0728H23.6762L23.6762 78.2764Z"
        fill="currentColor"
      />
      <path
        d="M187.516 60.0869H205.719V41.8834H187.516V60.0869Z"
        fill="currentColor"
      />
      <path
        d="M169.313 60.0869H187.516V41.8834H169.313V60.0869Z"
        fill="currentColor"
      />
      <path
        d="M132.907 60.0869H151.109V41.8834H132.907V60.0869Z"
        fill="currentColor"
      />
      <path
        d="M114.707 60.0869H132.91V41.8834H114.707V60.0869Z"
        fill="currentColor"
      />
      <path
        d="M78.2855 60.0869H96.4883V41.8834H78.2855V60.0869Z"
        fill="currentColor"
      />
      <path
        d="M41.8793 60.0869H60.082V41.8834H41.8793V60.0869Z"
        fill="currentColor"
      />
      <path
        d="M269.437 50.9785H251.234V69.182H269.437V50.9785Z"
        fill="currentColor"
      />
      <path
        d="M242.14 96.494H296.762V23.666H223.938V96.494H242.14ZM242.14 60.087V41.8835H278.546V78.2905H242.14V60.087Z"
        fill="currentColor"
      />
      <path
        d="M187.516 41.8838H205.719V23.6803L187.516 23.6803V41.8838Z"
        fill="currentColor"
      />
      <path
        d="M151.11 41.8838H169.312V23.6803L151.11 23.6803V41.8838Z"
        fill="currentColor"
      />
      <path
        d="M114.707 41.8838H132.91V23.6803L114.707 23.6803V41.8838Z"
        fill="currentColor"
      />
      <path
        d="M60.0824 41.8838H78.2852V23.6803L60.0824 23.6803V41.8838Z"
        fill="currentColor"
      />
      <path
        d="M41.8793 41.8838H60.082V23.6803L41.8793 23.6803V41.8838Z"
        fill="currentColor"
      />
      <path
        d="M23.6762 41.8838H41.8789V23.6803L23.6762 23.6803L23.6762 41.8838Z"
        fill="currentColor"
      />
      <path
        d="M2.09548 87.7206C0.935982 87.7206 0 86.7845 0 85.625V2.09557C0 0.936021 0.935982 0 2.09548 0H96.49C97.6495 0 98.5854 0.936021 98.5854 2.09557C98.5854 3.25512 97.6495 4.19114 96.49 4.19114H4.19096V85.625C4.19096 86.7845 3.25498 87.7206 2.09548 87.7206Z"
        fill="currentColor"
      />
      <path
        d="M318.33 87.7206C317.17 87.7206 316.234 86.7845 316.234 85.625V4.19114H223.935C222.776 4.19114 221.84 3.25512 221.84 2.09557C221.84 0.936021 222.776 0 223.935 0H318.33C319.489 0 320.425 0.936021 320.425 2.09557V85.625C320.425 86.7845 319.489 87.7206 318.33 87.7206Z"
        fill="currentColor"
      />
      <path
        d="M318.332 320.426H234.806C233.647 320.426 232.711 319.49 232.711 318.331C232.711 317.171 233.647 316.235 234.806 316.235H316.237V223.932C316.237 222.773 317.173 221.837 318.332 221.837C319.492 221.837 320.428 222.773 320.428 223.932V318.331C320.428 319.49 319.492 320.426 318.332 320.426Z"
        fill="currentColor"
      />
      <path
        d="M85.6214 320.426H2.09548C0.935982 320.426 0 319.49 0 318.331V223.932C0 222.773 0.935982 221.837 2.09548 221.837C3.25498 221.837 4.19096 222.773 4.19096 223.932V316.235H85.6214C86.7809 316.235 87.7169 317.171 87.7169 318.331C87.7169 319.49 86.7809 320.426 85.6214 320.426Z"
        fill="currentColor"
      />
    </svg>
  ),
  OClockCountdownIcon: (props) => (
    <svg
      width="358"
      height="346"
      viewBox="0 0 358 346"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M186.683 177.908C186.683 178.375 186.594 178.823 186.417 179.258C186.239 179.688 185.982 180.071 185.655 180.398C185.323 180.729 184.94 180.982 184.51 181.164C184.08 181.341 183.627 181.43 183.159 181.43C182.697 181.43 182.244 181.341 181.814 181.164C181.384 180.982 181 180.729 180.669 180.398C180.342 180.071 180.085 179.688 179.907 179.258C179.729 178.823 179.641 178.375 179.641 177.908C179.641 177.44 179.729 176.992 179.907 176.562C180.085 176.127 180.342 175.749 180.669 175.417C181 175.086 181.384 174.833 181.814 174.656C182.244 174.478 182.697 174.385 183.159 174.385C183.627 174.385 184.08 174.478 184.51 174.656C184.94 174.833 185.323 175.086 185.655 175.417C185.982 175.749 186.239 176.127 186.417 176.562C186.594 176.992 186.683 177.44 186.683 177.908Z"
        fill="currentColor"
      />
      <path
        d="M301.169 284.445C254.055 333.75 181.403 348.275 118.878 320.542C40.0576 285.763 2.19249 195.078 33.0158 114.957L36.0332 132.599C36.4724 135.678 39.5566 137.878 42.6362 137C45.7204 136.122 47.4821 133.477 46.5989 130.398L38.7403 92.5075C38.2963 90.7461 36.9785 88.9847 34.7775 88.5456C33.0158 88.1017 30.8148 88.5456 29.4923 89.8631L1.65075 118.576C-0.55025 120.777 -0.55025 124.295 1.65075 126.5C3.85175 128.701 7.37521 128.701 9.57621 126.5L22.0061 113.635C-10.5742 203.441 35.6554 302.494 125.48 335.067C189.767 358.4 261.981 341.674 309.534 292.369C311.735 290.169 311.735 286.646 309.973 284.445C305.571 280.923 302.047 284.002 301.169 284.445Z"
        fill="currentColor"
      />
      <path
        d="M261.1 30.4343C263.745 31.7565 266.824 30.8735 268.586 28.2338C269.908 25.5894 269.025 22.0713 266.385 20.7491C266.385 20.7491 248.333 12.3861 245.688 11.5031C243.048 10.1809 239.524 11.5031 238.206 14.1475C236.884 16.7872 238.206 20.3099 240.847 21.6274C241.286 21.1883 257.581 28.2338 261.1 30.4343Z"
        fill="currentColor"
      />
      <path
        d="M148.378 14.5863C148.817 14.5863 163.346 11.9419 170.393 11.5027C173.477 11.0635 175.678 8.42383 175.234 5.77944C175.234 2.70054 172.154 0.5 169.07 0.5C169.07 0.5 154.102 2.2567 146.616 4.01807C143.532 4.90109 141.77 7.54081 142.654 10.6244C143.532 12.8249 145.733 14.5863 148.378 14.5863Z"
        fill="currentColor"
      />
      <path
        d="M298.522 58.1662C299.405 59.0446 302.929 61.2498 306.447 58.1662C308.653 55.9657 308.653 52.443 306.447 50.2424C301.167 44.9583 295.442 40.118 289.279 35.2731C286.634 33.5117 283.554 33.9556 281.353 36.1561C279.591 38.7958 280.031 41.8794 282.232 44.08C288.395 48.481 293.681 53.326 298.522 58.1662Z"
        fill="currentColor"
      />
      <path
        d="M217.51 14.1468C217.51 14.1468 222.795 15.4643 224.113 9.74105C224.996 5.77914 222.356 3.5786 220.15 3.13942C212.669 1.81722 205.182 0.499702 197.696 0.0558552C194.612 -0.383319 191.972 1.81722 191.532 4.90079C191.093 7.97968 193.294 10.6241 196.374 11.0632C195.934 11.0632 210.463 12.8246 217.51 14.1468Z"
        fill="currentColor"
      />
      <path
        d="M106.108 30.8727C112.272 27.35 118.88 24.7102 125.483 22.0705C128.123 20.7483 129.885 17.6648 128.567 15.025C127.245 12.3853 124.16 10.624 121.52 11.9415C114.473 14.5859 107.431 18.1086 100.823 21.6267C98.183 22.9489 96.8605 26.4716 98.6223 29.1113C101.267 33.0732 105.23 31.3119 106.108 30.8727Z"
        fill="currentColor"
      />
      <path
        d="M342.555 139.166C342.994 141.811 345.195 144.451 349.158 143.572C352.242 143.128 354.003 140.049 353.564 136.966C353.564 136.966 350.041 122.001 347.396 114.956C346.517 111.872 343.433 110.555 340.354 111.433C337.709 112.316 335.952 115.395 336.83 118.039C336.83 118.479 341.232 132.126 342.555 139.166Z"
        fill="currentColor"
      />
      <path
        d="M348.284 206.962C345.2 206.084 342.56 207.841 341.676 210.924C339.919 217.97 337.714 224.571 335.513 231.173C334.634 233.817 335.957 237.34 338.597 238.219C342.12 239.541 344.761 237.34 345.639 235.135C348.284 228.094 350.485 220.609 352.247 213.564C353.125 210.485 351.364 207.841 348.284 206.962Z"
        fill="currentColor"
      />
      <path
        d="M331.548 252.306C328.908 250.989 325.384 251.867 324.062 254.068C320.543 260.23 316.58 265.953 312.174 271.677C310.417 274.316 310.856 277.4 313.057 279.601C315.258 281.801 318.781 280.923 320.982 278.722C325.824 272.56 329.786 266.393 333.749 259.791C335.072 257.151 334.193 253.629 331.548 252.306Z"
        fill="currentColor"
      />
      <path
        d="M326.708 95.5864C327.587 97.3478 331.11 99.1092 334.195 97.787C339.036 95.5864 336.835 91.1853 336.396 90.3023C332.872 83.7007 328.909 77.099 324.063 70.9366C322.306 68.2922 318.344 67.853 316.138 70.0536C313.937 71.8149 313.498 74.8985 315.259 77.5382C315.259 77.5382 323.185 89.424 326.708 95.5864Z"
        fill="currentColor"
      />
      <path
        d="M242.605 83.2612C244.367 83.2612 246.129 82.3782 247.446 80.6168L251.853 73.1369C253.171 70.4925 251.853 66.9744 249.208 65.6522C247.007 64.33 243.928 65.213 242.166 67.4136L237.759 74.8982C235.119 78.4163 237.759 82.8221 242.605 83.2612Z"
        fill="currentColor"
      />
      <path
        d="M186.683 66.9739C189.767 66.9739 191.968 64.7687 191.968 61.6898V52.883C191.968 49.8041 189.328 47.6035 186.683 47.6035C184.043 47.6035 181.402 50.2432 181.402 52.883V61.6898C181.402 64.3295 183.603 66.9739 186.683 66.9739Z"
        fill="currentColor"
      />
      <path
        d="M123.281 63.0072C120.641 64.3294 119.758 67.8521 121.08 70.4919L125.482 77.9765C126.361 79.7379 129.445 81.9384 132.968 80.1771C135.608 78.8595 136.492 75.3368 135.169 72.6924L130.767 65.2124C128.566 60.8067 124.16 62.568 123.281 63.0072Z"
        fill="currentColor"
      />
      <path
        d="M81.4539 236.457L88.9354 232.056C91.5803 230.734 92.4589 227.211 91.1364 224.571C89.8186 221.932 86.2951 221.049 83.6549 222.371L76.1687 226.772C73.5237 228.094 72.6452 231.617 73.9677 234.257C74.8462 236.457 77.4911 238.658 81.4539 236.457Z"
        fill="currentColor"
      />
      <path
        d="M117.556 273.877C115.794 276.522 117.117 281.801 122.397 282.245C124.159 282.245 125.921 281.362 127.243 279.601L131.645 272.116C133.407 269.476 132.528 265.953 129.883 264.636C127.243 262.875 124.159 263.753 122.397 266.393C121.958 266.393 117.556 273.877 117.556 273.877Z"
        fill="currentColor"
      />
      <path
        d="M176.996 285.322V294.128C176.996 297.207 179.197 299.847 182.281 299.847C185.365 299.847 187.566 297.647 187.566 294.568V285.761C188.006 277.837 176.996 277.398 176.996 285.322Z"
        fill="currentColor"
      />
      <path
        d="M235.998 266.835C233.357 268.152 232.479 271.675 233.797 274.315L238.203 281.799C239.082 283.561 240.844 284.883 243.045 284.883C243.928 284.883 244.806 284.444 245.685 284C248.33 282.682 249.208 279.16 247.891 276.52L243.484 269.035C242.166 266.391 238.643 265.513 235.998 266.835Z"
        fill="currentColor"
      />
      <path
        d="M290.597 231.172L283.115 226.771C280.47 225.01 276.947 225.893 275.629 228.533C274.306 231.172 274.746 234.256 277.391 236.017C277.391 236.017 277.391 236.017 277.83 236.017L285.316 240.418C287.956 242.18 291.48 241.301 292.798 238.657C292.798 238.657 292.798 238.657 292.798 238.218C294.12 236.017 293.242 232.495 290.597 231.172Z"
        fill="currentColor"
      />
      <path
        d="M296.764 169.984C293.679 169.984 291.478 172.185 291.039 175.268C291.039 178.347 293.24 180.992 296.32 180.992H305.128C308.208 180.992 310.409 178.347 310.409 175.708C310.409 173.068 307.769 170.424 305.128 170.424H296.764V169.984Z"
        fill="currentColor"
      />
      <path
        d="M282.675 125.081C283.558 125.081 284.437 124.641 285.32 124.202L292.802 119.797C295.447 118.479 296.325 114.956 295.007 112.317C293.685 109.672 290.161 108.794 287.521 110.116L280.035 114.517C277.395 115.835 276.511 119.357 277.834 122.002C278.712 123.763 280.474 124.641 282.675 125.081Z"
        fill="currentColor"
      />
      <path
        d="M185.367 179.229C185.807 178.79 185.807 177.907 185.807 177.468C185.807 177.029 185.367 176.146 184.923 175.707C184.484 175.268 183.606 175.268 183.162 175.268C182.722 175.268 181.844 175.707 181.405 176.146C180.521 177.029 180.521 178.79 181.405 179.669C182.722 180.552 184.045 180.552 185.367 179.229Z"
        fill="currentColor"
      />
      <path
        d="M184.045 272.998C239.523 272.998 283.997 228.095 283.997 173.068C283.997 118.04 239.523 73.1367 184.045 73.1367C128.567 73.1367 84.0938 117.596 84.0938 173.068C84.0938 228.095 129.006 272.998 184.045 272.998ZM121.081 122.002C123.282 119.797 126.805 119.357 129.006 121.558L177.882 165.144C179.199 164.261 180.961 164.261 182.723 163.822C184.485 163.822 185.807 163.822 187.569 164.261L239.967 105.71C241.724 103.51 245.248 102.631 247.893 104.832C250.094 106.593 250.972 110.116 248.771 112.756L195.494 172.185C196.373 173.507 196.373 175.268 196.812 177.029C196.812 184.514 191.092 190.677 183.606 190.677C176.12 190.677 169.956 184.953 169.956 177.469C169.956 176.146 169.956 174.829 170.395 173.507L121.52 129.482C119.319 127.725 119.319 124.202 121.081 122.002Z"
        fill="currentColor"
      />
    </svg>
  ),
  RemoteControlIcon: (props) => (
    <svg
      width="201"
      height="476"
      viewBox="0 0 201 476"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_10031_72)">
        <path
          d="M174.32 413.643H26.6915C11.9813 413.643 0 401.672 0 386.96V91.9287C0 77.217 11.9696 65.2461 26.6915 65.2461H174.32C189.03 65.2461 201.012 77.217 201.012 91.9287V386.948C201.012 401.66 189.042 413.631 174.32 413.631V413.643ZM26.6915 73.4453C16.5021 73.4453 8.19835 81.7382 8.19835 91.9287V386.948C8.19835 397.139 16.4904 405.432 26.6915 405.432H174.32C184.51 405.432 192.813 397.139 192.813 386.948V91.9287C192.813 81.7382 184.521 73.4453 174.32 73.4453H26.6915Z"
          fill="currentColor"
        />
        <path
          d="M100.501 201.595C71.666 201.595 48.2188 178.133 48.2188 149.307C48.2188 120.481 71.6777 97.0195 100.501 97.0195C129.324 97.0195 152.783 120.481 152.783 149.307C152.783 178.133 129.324 201.595 100.501 201.595ZM100.501 105.219C76.1868 105.219 56.4171 125.002 56.4171 149.307C56.4171 173.612 76.1985 193.396 100.501 193.396C124.803 193.396 144.584 173.612 144.584 149.307C144.584 125.002 124.803 105.219 100.501 105.219Z"
          fill="currentColor"
        />
        <path
          d="M100.498 369.796C61.6613 369.796 30.0625 338.194 30.0625 299.353C30.0625 260.512 61.6613 228.91 100.498 228.91C139.335 228.91 170.934 260.512 170.934 299.353C170.934 338.194 139.335 369.796 100.498 369.796ZM100.498 237.109C66.1821 237.109 38.2608 265.034 38.2608 299.353C38.2608 333.673 66.1821 361.597 100.498 361.597C134.814 361.597 162.735 333.673 162.735 299.353C162.735 265.034 134.814 237.109 100.498 237.109Z"
          fill="currentColor"
        />
        <path
          d="M100.501 351.64C71.666 351.64 48.2188 328.178 48.2188 299.352C48.2188 270.526 71.6777 247.064 100.501 247.064C129.324 247.064 152.783 270.526 152.783 299.352C152.783 328.178 129.324 351.64 100.501 351.64ZM100.501 255.264C76.1868 255.264 56.4171 275.047 56.4171 299.352C56.4171 323.657 76.1985 343.44 100.501 343.44C124.803 343.44 144.584 323.657 144.584 299.352C144.584 275.047 124.803 255.264 100.501 255.264Z"
          fill="currentColor"
        />
        <circle cx="100.5" cy="148.5" r="13.5" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M92.7333 274.717C92.201 274.317 91.5679 274.074 90.9051 274.014C90.2424 273.955 89.576 274.081 88.9808 274.378C88.3856 274.676 87.885 275.133 87.5352 275.699C87.1853 276.266 87 276.918 87 277.583V320.583C87 321.249 87.1853 321.901 87.5352 322.467C87.885 323.033 88.3856 323.491 88.9808 323.788C89.576 324.086 90.2424 324.212 90.9051 324.152C91.5679 324.092 92.201 323.849 92.7333 323.45L121.4 301.95C121.845 301.616 122.206 301.183 122.455 300.686C122.704 300.188 122.833 299.64 122.833 299.083C122.833 298.527 122.704 297.978 122.455 297.481C122.206 296.983 121.845 296.55 121.4 296.217L92.7333 274.717Z"
          fill="currentColor"
        />
        <mask
          id="mask0_10031_72"
          maskUnits="userSpaceOnUse"
          x="51"
          y="0"
          width="101"
          height="26"
        >
          <path d="M51 0H151.667V25.9531H51V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_10031_72)">
          <mask
            id="mask1_10031_72"
            maskUnits="userSpaceOnUse"
            x="-87"
            y="-33"
            width="376"
            height="376"
          >
            <path
              d="M-86.9258 154.918L100.669 -32.6738L288.261 154.918L100.669 342.513L-86.9258 154.918Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_10031_72)">
            <mask
              id="mask2_10031_72"
              maskUnits="userSpaceOnUse"
              x="-87"
              y="-33"
              width="376"
              height="376"
            >
              <path
                d="M-86.9258 154.918L100.669 -32.6738L288.261 154.918L100.669 342.513L-86.9258 154.918Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask2_10031_72)">
              <path
                d="M149.646 23.9893C147.588 26.0445 144.258 26.0415 142.206 23.9893C142.095 23.8756 128.581 10.9882 101.224 10.6502C74.0203 10.3123 60.8748 23.381 60.4477 23.9156C60.4293 23.934 60.4109 23.9524 60.3955 23.9647C58.371 25.9892 55.0838 26.0353 53.0163 24.0477C50.9334 22.0385 50.8474 18.7391 52.8412 16.6408C53.5324 15.8759 69.2677 -0.26803 101.353 0.128271C133.257 0.524572 148.992 15.8943 149.646 16.5487C151.698 18.6039 151.701 21.931 149.646 23.9893Z"
                fill="currentColor"
              />
            </g>
          </g>
        </g>
        <mask
          id="mask3_10031_72"
          maskUnits="userSpaceOnUse"
          x="73"
          y="26"
          width="57"
          height="19"
        >
          <path d="M73.0234 26H129.648V44.0885H73.0234V26Z" fill="white" />
        </mask>
        <g mask="url(#mask3_10031_72)">
          <mask
            id="mask4_10031_72"
            maskUnits="userSpaceOnUse"
            x="-87"
            y="-37"
            width="376"
            height="376"
          >
            <path
              d="M-86.9219 151.031L100.673 -36.5605L288.265 151.031L100.673 338.626L-86.9219 151.031Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask4_10031_72)">
            <mask
              id="mask5_10031_72"
              maskUnits="userSpaceOnUse"
              x="-87"
              y="-37"
              width="376"
              height="376"
            >
              <path
                d="M-86.9219 151.031L100.673 -36.5605L288.265 151.031L100.673 338.626L-86.9219 151.031Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask5_10031_72)">
              <path
                d="M127.328 42.4173C125.269 44.4756 121.942 44.4726 119.887 42.4173C119.675 42.2146 113.571 36.5189 101.289 36.5189C89.0064 36.5189 82.9052 42.2146 82.6502 42.4603C80.5642 44.451 77.2494 44.4173 75.2341 42.3559C73.2188 40.2945 73.2127 37.0166 75.2526 34.9798C75.6212 34.6111 84.4259 26 101.289 26C118.154 26 126.959 34.6111 127.328 34.9798C129.38 37.0319 129.383 40.3621 127.328 42.4173Z"
                fill="currentColor"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  FullScreenIcon: (props) => (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.2431 15.2431V1.17254H10.5529V7.24633L3.30658 0L0 3.30658L7.24633 10.5529H1.17254V15.2431H15.2431ZM43.3842 15.2431V10.5529H37.3104L44.5567 3.30658L41.2501 0L34.0038 7.24633V1.17254H29.3136V15.2431H43.3842ZM1.17254 29.3136V34.0038H7.24633L0 41.2501L3.30658 44.5567L10.5529 37.3104V43.3842H15.2431V29.3136H1.17254ZM29.3136 29.3136V43.3842H34.0038V37.3104L41.2501 44.5567L44.5567 41.2501L37.3104 34.0038H43.3842V29.3136H29.3136Z"
        fill="currentColor"
      />
    </svg>
  ),
  ReplayIcon: (props) => (
    <svg
      width="47"
      height="38"
      viewBox="0 0 47 38"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.0046 17.3182L40.4174 11.7161C39.6851 11.0543 38.5816 11.0543 37.9189 11.7161L35.124 14.5184L32.2595 17.3182C31.6716 18.0549 31.8934 18.5694 32.7726 18.5694H36.0832C36.0832 25.7924 30.2742 31.6892 23.0728 31.6892C19.4709 31.6892 16.1629 30.2157 13.8089 27.858L9.47467 32.2037C13.0018 35.7428 17.7073 37.8781 23.0728 37.8781C33.7317 37.8781 42.2583 29.1842 42.2583 18.5694H45.4168C46.5203 18.5694 46.6647 18.0549 46.0046 17.3182ZM14.1054 20.4126C14.7654 19.8232 14.5463 19.1614 13.5897 19.1614H10.2817C10.2817 11.9384 16.0881 6.18894 23.292 6.18894C26.894 6.18894 30.1994 7.59011 32.5534 9.9478L36.8902 5.52713C33.51 2.13536 28.6601 0 23.292 0C12.7079 0 4.10913 8.54663 4.10913 19.1614H0.948086C-0.0832513 19.1614 -0.302411 19.8232 0.434996 20.4126L3.22734 23.2874L6.01969 26.0871C6.68232 26.8239 7.85547 26.8239 8.44591 26.0871L11.3852 23.2874L14.1054 20.4126Z"
        fill="currentColor"
      />
    </svg>
  ),
  VeryBadEmojiIcon: (props) => (
    <svg
      width="115"
      height="113"
      viewBox="0 0 115 113"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M108.079 1.23047C111.009 1.23047 113.39 3.57044 113.39 6.45044C113.39 9.33044 111.009 11.6804 108.079 11.6804C105.149 11.6804 102.77 9.34044 102.77 6.45044C102.77 3.56044 105.149 1.23047 108.079 1.23047Z"
        fill="#C45361"
      />
      <path
        d="M5.70776 102.13C8.16776 102.13 10.1578 104.09 10.1578 106.51C10.1578 108.93 8.16776 110.89 5.70776 110.89C3.24776 110.89 1.25781 108.93 1.25781 106.51C1.25781 104.09 3.24776 102.13 5.70776 102.13Z"
        fill="#C45361"
      />
      <path
        d="M57.1194 2.71973C87.6394 2.71973 112.379 27.0497 112.379 57.0597C112.379 87.0697 87.6394 111.4 57.1194 111.4C26.5994 111.4 1.85938 87.0697 1.85938 57.0597C1.85938 27.0497 26.5994 2.71973 57.1194 2.71973Z"
        fill="#FDD92E"
      />
      <path
        d="M101.299 104.28C102.509 104.28 103.489 103.318 103.489 102.13C103.489 100.943 102.509 99.9805 101.299 99.9805C100.09 99.9805 99.1094 100.943 99.1094 102.13C99.1094 103.318 100.09 104.28 101.299 104.28Z"
        fill="#010101"
      />
      <path
        d="M10.1588 11.6797C11.3688 11.6797 12.3488 12.6397 12.3488 13.8297C12.3488 15.0197 11.3688 15.9797 10.1588 15.9797C8.94881 15.9797 7.96875 15.0197 7.96875 13.8297C7.96875 12.6397 8.94881 11.6797 10.1588 11.6797Z"
        fill="#010101"
      />
      <path
        d="M74.9925 53.0996C74.5025 52.6196 74.5025 51.8296 74.9925 51.3496L87.6726 38.8795C88.1626 38.3995 88.9625 38.3995 89.4525 38.8795C89.9425 39.3595 89.9425 40.1495 89.4525 40.6295L76.7725 53.0996C76.2825 53.5796 75.4825 53.5796 74.9925 53.0996Z"
        fill="#010101"
      />
      <path
        d="M87.6726 53.0996L74.9925 40.6295C74.5025 40.1495 74.5025 39.3595 74.9925 38.8795C75.4825 38.3995 76.2825 38.3995 76.7725 38.8795L89.4525 51.3496C89.9425 51.8296 89.9425 52.6196 89.4525 53.0996C88.9625 53.5796 88.1626 53.5796 87.6726 53.0996Z"
        fill="#010101"
      />
      <path
        d="M24.7972 53.0996C24.3072 52.6196 24.3072 51.8296 24.7972 51.3496L37.4771 38.8795C37.9671 38.3995 38.7671 38.3995 39.2571 38.8795C39.7471 39.3595 39.7471 40.1495 39.2571 40.6295L26.5771 53.0996C26.0871 53.5796 25.2872 53.5796 24.7972 53.0996Z"
        fill="#010101"
      />
      <path
        d="M37.4771 53.0996L24.7972 40.6295C24.3072 40.1495 24.3072 39.3595 24.7972 38.8795C25.2872 38.3995 26.0871 38.3995 26.5771 38.8795L39.2571 51.3496C39.7471 51.8296 39.7471 52.6196 39.2571 53.0996C38.7671 53.5796 37.9671 53.5796 37.4771 53.0996Z"
        fill="#010101"
      />
      <path
        d="M34.3717 76.2199C33.7917 75.8399 33.6417 75.0698 34.0217 74.4998C44.2717 59.4198 67.7417 58.3398 80.1817 74.4398C80.6017 74.9798 80.4916 75.7598 79.9416 76.1798C79.3916 76.5898 78.5917 76.4898 78.1717 75.9398C66.8917 61.3398 45.5117 62.0498 36.1117 75.8798C35.8717 76.2398 34.9417 76.5999 34.3617 76.2199H34.3717Z"
        fill="#010101"
      />
      <path
        d="M108.078 2.47003C105.848 2.47003 104.028 4.26001 104.028 6.45001C104.028 8.64001 105.848 10.44 108.078 10.44C110.308 10.44 112.128 8.65001 112.128 6.45001C112.128 4.25001 110.308 2.47003 108.078 2.47003ZM108.078 12.92C104.458 12.92 101.508 10.02 101.508 6.46002C101.508 2.90002 104.458 0 108.078 0C111.698 0 114.648 2.90002 114.648 6.46002C114.648 10.02 111.698 12.92 108.078 12.92Z"
        fill="#010101"
      />
      <path
        d="M5.70996 103.38C3.94996 103.38 2.52002 104.79 2.52002 106.52C2.52002 108.25 3.94996 109.66 5.70996 109.66C7.46996 109.66 8.90002 108.25 8.90002 106.52C8.90002 104.79 7.46996 103.38 5.70996 103.38ZM5.70996 112.13C2.55996 112.13 0 109.61 0 106.52C0 103.43 2.55996 100.9 5.70996 100.9C8.85996 100.9 11.42 103.42 11.42 106.52C11.42 109.62 8.85996 112.13 5.70996 112.13Z"
        fill="#010101"
      />
      <path
        d="M57.1294 3.95044C27.3494 3.95044 3.12939 27.7704 3.12939 57.0504C3.12939 86.3304 27.3594 110.15 57.1294 110.15C86.8994 110.15 111.129 86.3304 111.129 57.0504C111.129 27.7704 86.9094 3.95044 57.1294 3.95044ZM57.1294 112.64C25.8894 112.64 0.609375 87.7804 0.609375 57.0604C0.609375 26.3404 25.8894 1.48047 57.1294 1.48047C88.3694 1.48047 113.649 26.3404 113.649 57.0604C113.649 87.7804 88.3694 112.64 57.1294 112.64Z"
        fill="#010101"
      />
    </svg>
  ),

  BadEmojiIcon: (props) => (
    <svg
      width="115"
      height="113"
      viewBox="0 0 115 113"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M57.8209 1.23047C88.5309 1.23047 113.431 25.9004 113.431 56.3304C113.431 86.7604 88.5309 111.44 57.8209 111.44C27.1109 111.44 2.21094 86.7704 2.21094 56.3304C2.21094 25.8904 27.1109 1.23047 57.8209 1.23047Z"
        fill="#FDD92E"
      />
      <path
        d="M77.7399 67.9102V79.8901C77.7399 82.8601 75.2898 85.2902 72.2898 85.2902C70.7898 85.2902 69.4298 84.6801 68.4398 83.7001C67.4498 82.7201 66.8398 81.3701 66.8398 79.8901V67.9102H77.7399Z"
        fill="#C45361"
      />
      <path
        d="M5.57043 102.72C7.97043 102.72 9.9104 104.64 9.9104 107.02C9.9104 109.4 7.97043 111.32 5.57043 111.32C3.17043 111.32 1.23047 109.39 1.23047 107.02C1.23047 104.65 3.17043 102.72 5.57043 102.72Z"
        fill="#C45361"
      />
      <path
        d="M107.493 11.7698C110.353 11.7698 112.672 9.47299 112.672 6.63977C112.672 3.80655 110.353 1.50977 107.493 1.50977C104.632 1.50977 102.312 3.80655 102.312 6.63977C102.312 9.47299 104.632 11.7698 107.493 11.7698Z"
        fill="#C45361"
      />
      <path
        d="M104.453 107.03C105.634 107.03 106.593 106.081 106.593 104.91C106.593 103.739 105.634 102.79 104.453 102.79C103.271 102.79 102.312 103.739 102.312 104.91C102.312 106.081 103.271 107.03 104.453 107.03Z"
        fill="#010101"
      />
      <path
        d="M9.90955 10.8699C11.0914 10.8699 12.0496 9.92072 12.0496 8.74988C12.0496 7.57903 11.0914 6.62988 9.90955 6.62988C8.72766 6.62988 7.76953 7.57903 7.76953 8.74988C7.76953 9.92072 8.72766 10.8699 9.90955 10.8699Z"
        fill="#010101"
      />
      <path
        d="M57.8204 2.44995C27.8304 2.44995 3.44043 26.62 3.44043 56.34C3.44043 86.06 27.8404 110.23 57.8204 110.23C87.8004 110.23 112.2 86.06 112.2 56.34C112.2 26.62 87.8004 2.44995 57.8204 2.44995ZM57.8204 112.66C42.6404 112.66 28.3605 106.8 17.6305 96.16C6.90049 85.52 0.980469 71.38 0.980469 56.33C0.980469 41.28 6.89049 27.14 17.6305 16.5C28.3705 5.86 42.6404 0 57.8204 0C73.0004 0 87.2805 5.86 98.0105 16.5C108.74 27.14 114.66 41.28 114.66 56.33C114.66 71.38 108.75 85.52 98.0105 96.16C87.2705 106.8 73.0004 112.66 57.8204 112.66Z"
        fill="#010101"
      />
      <path
        d="M47.3814 37.3804C47.0714 37.3804 46.7514 37.2604 46.5114 37.0204L37.6412 28.2304C37.1612 27.7504 37.1612 26.9804 37.6412 26.5104C38.1212 26.0304 38.9014 26.0304 39.3814 26.5104L48.2514 35.3004C48.7314 35.7804 48.7314 36.5504 48.2514 37.0204C48.0114 37.2604 47.7014 37.3804 47.3814 37.3804Z"
        fill="#010101"
      />
      <path
        d="M29.6402 37.3804C29.3302 37.3804 29.0102 37.2604 28.7702 37.0204C28.2902 36.5404 28.2902 35.7704 28.7702 35.3004L37.6402 26.5104C38.1202 26.0304 38.9003 26.0304 39.3803 26.5104C39.8603 26.9904 39.8603 27.7604 39.3803 28.2304L30.5103 37.0204C30.2703 37.2604 29.9602 37.3804 29.6402 37.3804Z"
        fill="#010101"
      />
      <path
        d="M85.9984 37.3804C85.6884 37.3804 85.3684 37.2604 85.1284 37.0204L76.2584 28.2304C75.7784 27.7504 75.7784 26.9804 76.2584 26.5104C76.7384 26.0304 77.5184 26.0304 77.9984 26.5104L86.8684 35.3004C87.3484 35.7804 87.3484 36.5504 86.8684 37.0204C86.6284 37.2604 86.3184 37.3804 85.9984 37.3804Z"
        fill="#010101"
      />
      <path
        d="M68.2614 37.3804C67.9514 37.3804 67.6312 37.2604 67.3912 37.0204C66.9112 36.5404 66.9112 35.7704 67.3912 35.3004L76.2614 26.5104C76.7414 26.0304 77.5214 26.0304 78.0014 26.5104C78.4814 26.9904 78.4814 27.7604 78.0014 28.2304L69.1314 37.0204C68.8914 37.2604 68.5814 37.3804 68.2614 37.3804Z"
        fill="#010101"
      />
      <path
        d="M72.2971 86.52C70.5171 86.52 68.8471 85.83 67.5771 84.58C66.3071 83.33 65.6172 81.67 65.6172 79.91V67.93C65.6172 67.26 66.1672 66.71 66.8472 66.71C67.5272 66.71 68.0771 67.25 68.0771 67.93V79.91C68.0771 81.02 68.5171 82.07 69.3171 82.86C70.1171 83.65 71.1771 84.09 72.2971 84.09C74.6271 84.09 76.5171 82.21 76.5171 79.91V67.93C76.5171 67.26 77.0672 66.71 77.7472 66.71C78.4272 66.71 78.9772 67.25 78.9772 67.93V79.91C78.9772 83.56 75.9871 86.53 72.2971 86.53V86.52Z"
        fill="#010101"
      />
      <path
        d="M83.8198 69.1402H26.5698C25.8898 69.1402 25.3398 68.6002 25.3398 67.9202C25.3398 67.2402 25.8898 66.7002 26.5698 66.7002H83.8198C84.4998 66.7002 85.0498 67.2402 85.0498 67.9202C85.0498 68.6002 84.4998 69.1402 83.8198 69.1402Z"
        fill="#010101"
      />
      <path
        d="M107.488 2.72028C105.308 2.72028 103.538 4.48031 103.538 6.63031C103.538 8.78031 105.308 10.5403 107.488 10.5403C109.668 10.5403 111.438 8.78031 111.438 6.63031C111.438 4.47031 109.668 2.72028 107.488 2.72028ZM107.488 12.9803C103.958 12.9803 101.078 10.1303 101.078 6.63031C101.078 3.13031 103.948 0.280273 107.488 0.280273C111.028 0.280273 113.898 3.13031 113.898 6.63031C113.898 10.1303 111.028 12.9803 107.488 12.9803Z"
        fill="#010101"
      />
      <path
        d="M5.56995 103.94C3.85995 103.94 2.45996 105.32 2.45996 107.02C2.45996 108.72 3.84995 110.1 5.56995 110.1C7.28995 110.1 8.67993 108.72 8.67993 107.02C8.67993 105.32 7.28995 103.94 5.56995 103.94ZM5.56995 112.54C2.49995 112.54 0 110.07 0 107.02C0 103.97 2.49995 101.51 5.56995 101.51C8.63995 101.51 11.1399 103.98 11.1399 107.02C11.1399 110.06 8.63995 112.54 5.56995 112.54Z"
        fill="#010101"
      />
    </svg>
  ),
  NormalEmojiIcon: (props) => (
    <svg
      width="115"
      height="113"
      viewBox="0 0 115 113"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M58.1988 3.91992C87.4588 3.91992 111.169 27.3499 111.169 56.2399C111.169 85.1299 87.4488 108.57 58.1988 108.57C28.9488 108.57 5.21875 85.1399 5.21875 56.2399C5.21875 27.3399 28.9388 3.91992 58.1988 3.91992Z"
        fill="#FDD92E"
      />
      <path
        d="M5.60046 102.8C8.01046 102.8 9.97046 104.73 9.97046 107.11C9.97046 109.49 8.02046 111.42 5.60046 111.42C3.18046 111.42 1.23047 109.49 1.23047 107.11C1.23047 104.73 3.18046 102.8 5.60046 102.8Z"
        fill="#C45361"
      />
      <path
        d="M108.21 11.5197C111.087 11.5197 113.42 9.21402 113.42 6.36975C113.42 3.52548 111.087 1.21973 108.21 1.21973C105.333 1.21973 103 3.52548 103 6.36975C103 9.21402 105.333 11.5197 108.21 11.5197Z"
        fill="#C45361"
      />
      <path
        d="M74.7795 34.5703C77.9795 34.5703 80.5595 37.1203 80.5595 40.2803C80.5595 43.4403 77.9795 45.9904 74.7795 45.9904C71.5795 45.9904 69.0195 43.4403 69.0195 40.2803C69.0195 37.1203 71.5995 34.5703 74.7795 34.5703Z"
        fill="#414141"
      />
      <path
        d="M41.6099 34.5703C44.8099 34.5703 47.3899 37.1203 47.3899 40.2803C47.3899 43.4403 44.8099 45.9904 41.6099 45.9904C38.4099 45.9904 35.8398 43.4403 35.8398 40.2803C35.8398 37.1203 38.4199 34.5703 41.6099 34.5703Z"
        fill="#414141"
      />
      <path
        d="M105.15 107.11C106.34 107.11 107.3 106.16 107.3 104.99C107.3 103.82 106.34 102.87 105.15 102.87C103.96 102.87 103 103.82 103 104.99C103 106.16 103.96 107.11 105.15 107.11Z"
        fill="#010101"
      />
      <path
        d="M9.96246 10.6199C11.1525 10.6199 12.1125 9.66988 12.1125 8.49988C12.1125 7.32988 11.1525 6.37988 9.96246 6.37988C8.77246 6.37988 7.8125 7.32988 7.8125 8.49988C7.8125 9.66988 8.77246 10.6199 9.96246 10.6199Z"
        fill="#010101"
      />
      <path
        d="M58.2022 5.14996C29.6722 5.14996 6.46216 28.0699 6.46216 56.2499C6.46216 84.4299 29.6722 107.35 58.2022 107.35C86.7322 107.35 109.942 84.4199 109.942 56.2499C109.942 28.0799 86.7322 5.14996 58.2022 5.14996ZM58.2022 109.79C43.7222 109.79 30.1022 104.22 19.8722 94.11C9.63219 84 3.99219 70.5499 3.99219 56.2499C3.99219 41.9499 9.63219 28.5 19.8722 18.39C30.1122 8.27995 43.7222 2.70996 58.2022 2.70996C72.6822 2.70996 86.2922 8.27995 96.5322 18.39C106.772 28.5 112.412 41.9499 112.412 56.2499C112.412 70.5499 106.772 84 96.5322 94.11C86.2922 104.22 72.6822 109.79 58.2022 109.79Z"
        fill="#010101"
      />
      <path
        d="M78.6495 74.98H37.7595C37.0795 74.98 36.5195 74.43 36.5195 73.76C36.5195 73.09 37.0695 72.54 37.7595 72.54H78.6495C79.3295 72.54 79.8895 73.09 79.8895 73.76C79.8895 74.43 79.3395 74.98 78.6495 74.98Z"
        fill="#010101"
      />
      <path
        d="M74.7812 35.7896C72.2812 35.7896 70.2513 37.7996 70.2513 40.2796C70.2513 42.7596 72.2812 44.7696 74.7812 44.7696C77.2812 44.7696 79.3213 42.7596 79.3213 40.2796C79.3213 37.7996 77.2812 35.7896 74.7812 35.7896ZM74.7812 47.2096C70.9213 47.2096 67.7812 44.0996 67.7812 40.2796C67.7812 36.4596 70.9213 33.3496 74.7812 33.3496C78.6412 33.3496 81.8013 36.4596 81.8013 40.2796C81.8013 44.0996 78.6512 47.2096 74.7812 47.2096Z"
        fill="#010101"
      />
      <path
        d="M41.6094 35.7896C39.1094 35.7896 37.0794 37.7996 37.0794 40.2796C37.0794 42.7596 39.1094 44.7696 41.6094 44.7696C44.1094 44.7696 46.1494 42.7596 46.1494 40.2796C46.1494 37.7996 44.1094 35.7896 41.6094 35.7896ZM41.6094 47.2096C37.7494 47.2096 34.6094 44.0996 34.6094 40.2796C34.6094 36.4596 37.7494 33.3496 41.6094 33.3496C45.4694 33.3496 48.6294 36.4596 48.6294 40.2796C48.6294 44.0996 45.4794 47.2096 41.6094 47.2096Z"
        fill="#010101"
      />
      <path
        d="M108.2 2.45001C106.01 2.45001 104.22 4.21 104.22 6.38C104.22 8.55 106 10.31 108.2 10.31C110.4 10.31 112.17 8.55 112.17 6.38C112.17 4.22001 110.39 2.45001 108.2 2.45001ZM108.2 12.7401C104.64 12.7401 101.75 9.88006 101.75 6.37006C101.75 2.86006 104.64 0 108.2 0C111.76 0 114.65 2.86006 114.65 6.37006C114.65 9.88006 111.76 12.7401 108.2 12.7401Z"
        fill="#010101"
      />
      <path
        d="M5.59998 104.02C3.86998 104.02 2.46997 105.41 2.46997 107.11C2.46997 108.81 3.86998 110.2 5.59998 110.2C7.32998 110.2 8.72998 108.81 8.72998 107.11C8.72998 105.41 7.32998 104.02 5.59998 104.02ZM5.59998 112.65C2.50998 112.65 0 110.17 0 107.11C0 104.05 2.50998 101.58 5.59998 101.58C8.68998 101.58 11.2 104.06 11.2 107.11C11.2 110.16 8.68998 112.65 5.59998 112.65Z"
        fill="#010101"
      />
    </svg>
  ),
  SatisfiedEmojiIcon: (props) => (
    <svg
      width="115"
      height="113"
      viewBox="0 0 115 113"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M58.2004 5.16016C86.7704 5.16016 109.92 28.0302 109.92 56.2402C109.92 84.4502 86.7704 107.33 58.2004 107.33C29.6304 107.33 6.48047 84.4602 6.48047 56.2402C6.48047 28.0202 29.6304 5.16016 58.2004 5.16016Z"
        fill="#FDD92E"
      />
      <path
        d="M5.60046 102.8C8.01046 102.8 9.97046 104.73 9.97046 107.11C9.97046 109.49 8.02046 111.42 5.60046 111.42C3.18046 111.42 1.23047 109.49 1.23047 107.11C1.23047 104.73 3.18046 102.8 5.60046 102.8Z"
        fill="#C45361"
      />
      <path
        d="M108.21 1.23047C111.09 1.23047 113.42 3.53043 113.42 6.38043C113.42 9.23043 111.09 11.5305 108.21 11.5305C105.33 11.5305 103 9.23043 103 6.38043C103 3.53043 105.33 1.23047 108.21 1.23047Z"
        fill="#C45361"
      />
      <path
        d="M105.15 107.11C106.34 107.11 107.3 106.16 107.3 104.99C107.3 103.82 106.34 102.87 105.15 102.87C103.96 102.87 103 103.82 103 104.99C103 106.16 103.96 107.11 105.15 107.11Z"
        fill="#010101"
      />
      <path
        d="M9.96252 10.6199C11.1525 10.6199 12.1125 9.66988 12.1125 8.49988C12.1125 7.32988 11.1525 6.37988 9.96252 6.37988C8.77252 6.37988 7.8125 7.32988 7.8125 8.49988C7.8125 9.66988 8.77252 10.6199 9.96252 10.6199Z"
        fill="#010101"
      />
      <path
        d="M58.1982 6.39044C30.3582 6.39044 7.71826 28.7604 7.71826 56.2504C7.71826 83.7404 30.3682 106.12 58.1982 106.12C86.0282 106.12 108.678 83.7504 108.678 56.2504C108.678 28.7504 86.0282 6.39044 58.1982 6.39044ZM58.1982 108.56C44.0482 108.56 30.7582 103.12 20.7482 93.2405C10.7482 83.3605 5.23828 70.2204 5.23828 56.2504C5.23828 42.2804 10.7482 29.1404 20.7482 19.2604C30.7482 9.38044 44.0482 3.94043 58.1982 3.94043C72.3482 3.94043 85.6383 9.38044 95.6483 19.2604C105.648 29.1404 111.158 42.2704 111.158 56.2504C111.158 70.2304 105.648 83.3605 95.6483 93.2405C85.6483 103.12 72.3482 108.56 58.1982 108.56Z"
        fill="#010101"
      />
      <path
        d="M49.5999 43.2598C49.2799 43.2598 48.9699 43.1399 48.7299 42.8999L40.9498 35.2199C40.4698 34.7399 40.4698 33.9699 40.9498 33.4899C41.4298 33.0099 42.2198 33.0099 42.6998 33.4899L50.4799 41.1699C50.9599 41.6499 50.9599 42.4199 50.4799 42.8999C50.2399 43.1399 49.9199 43.2598 49.6099 43.2598H49.5999Z"
        fill="#010101"
      />
      <path
        d="M34.0503 43.2598C33.7303 43.2598 33.4203 43.1399 33.1803 42.8999C32.7003 42.4199 32.7003 41.6499 33.1803 41.1699L40.9503 33.4899C41.4303 33.0099 42.2203 33.0099 42.7003 33.4899C43.1803 33.9699 43.1803 34.7399 42.7003 35.2199L34.9303 42.8999C34.6903 43.1399 34.3703 43.2598 34.0603 43.2598H34.0503Z"
        fill="#010101"
      />
      <path
        d="M83.4475 43.2598C83.1275 43.2598 82.8175 43.1399 82.5775 42.8999L74.7975 35.2199C74.3175 34.7399 74.3175 33.9699 74.7975 33.4899C75.2775 33.0099 76.0675 33.0099 76.5475 33.4899L84.3275 41.1699C84.8075 41.6499 84.8075 42.4199 84.3275 42.8999C84.0875 43.1399 83.7675 43.2598 83.4575 43.2598H83.4475Z"
        fill="#010101"
      />
      <path
        d="M67.8902 43.2598C67.5702 43.2598 67.2602 43.1399 67.0202 42.8999C66.5402 42.4199 66.5402 41.6499 67.0202 41.1699L74.8002 33.4899C75.2802 33.0099 76.0702 33.0099 76.5502 33.4899C77.0302 33.9699 77.0302 34.7399 76.5502 35.2199L68.7702 42.8999C68.5302 43.1399 68.2102 43.2598 67.9002 43.2598H67.8902Z"
        fill="#010101"
      />
      <path
        d="M57.6216 79.37C57.2616 79.37 56.9116 79.3699 56.5616 79.3499C45.4716 79.0199 35.6616 73.7099 29.6316 64.7999C29.2516 64.2399 29.4016 63.4799 29.9716 63.1099C30.5416 62.7399 31.3116 62.8899 31.6916 63.4499C37.2716 71.6999 46.3616 76.5999 56.6416 76.9099C67.6516 77.2399 77.9116 72.3099 84.7816 63.3899C85.1916 62.8499 85.9716 62.7499 86.5116 63.1599C87.0516 63.5699 87.1616 64.33 86.7516 64.87C83.0016 69.74 78.3416 73.4899 72.8916 76.0099C68.1216 78.2199 62.8616 79.37 57.6316 79.37H57.6216Z"
        fill="#010101"
      />
      <path
        d="M108.2 2.45001C106.01 2.45001 104.22 4.21 104.22 6.38C104.22 8.55 106 10.31 108.2 10.31C110.4 10.31 112.17 8.55 112.17 6.38C112.17 4.22001 110.39 2.45001 108.2 2.45001ZM108.2 12.7401C104.64 12.7401 101.75 9.88006 101.75 6.37006C101.75 2.86006 104.64 0 108.2 0C111.76 0 114.65 2.86006 114.65 6.37006C114.65 9.88006 111.76 12.7401 108.2 12.7401Z"
        fill="#010101"
      />
      <path
        d="M5.60004 104.02C3.87004 104.02 2.47003 105.41 2.47003 107.11C2.47003 108.81 3.87004 110.2 5.60004 110.2C7.33004 110.2 8.73004 108.81 8.73004 107.11C8.73004 105.41 7.33004 104.02 5.60004 104.02ZM5.60004 112.65C2.51004 112.65 0 110.17 0 107.11C0 104.05 2.51004 101.58 5.60004 101.58C8.69004 101.58 11.2 104.06 11.2 107.11C11.2 110.16 8.69004 112.65 5.60004 112.65Z"
        fill="#010101"
      />
    </svg>
  ),
  VerySatisfiedEmojiIcon: (props) => (
    <svg
      width="115"
      height="113"
      viewBox="0 0 115 113"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M57.13 5.08008C86.33 5.08008 110.01 28.4701 110.01 57.3101C110.01 86.1501 86.34 109.54 57.13 109.54C27.92 109.54 4.25 86.1501 4.25 57.3101C4.25 28.4701 27.92 5.08008 57.13 5.08008Z"
        fill="#FDD92E"
      />
      <path
        d="M108.091 11.7305C111.024 11.7305 113.401 9.37996 113.401 6.48047C113.401 3.58097 111.024 1.23047 108.091 1.23047C105.159 1.23047 102.781 3.58097 102.781 6.48047C102.781 9.37996 105.159 11.7305 108.091 11.7305Z"
        fill="#C45361"
      />
      <path
        d="M5.70782 102.59C8.16782 102.59 10.1578 104.56 10.1578 106.99C10.1578 109.42 8.16782 111.39 5.70782 111.39C3.24782 111.39 1.25781 109.42 1.25781 106.99C1.25781 104.56 3.24782 102.59 5.70782 102.59Z"
        fill="#C45361"
      />
      <path
        d="M57.1297 80.5898C61.0797 80.5898 64.4297 83.1399 65.5797 86.6699C60.3897 89.7599 53.8697 89.7599 48.6797 86.6699C49.8297 83.1399 53.1797 80.5898 57.1297 80.5898Z"
        fill="#C45361"
      />
      <path
        d="M73.5183 69.5098V72.7898C73.5183 78.6798 70.3383 83.8298 65.5783 86.6598C64.4283 83.1298 61.0783 80.5798 57.1283 80.5798C53.1783 80.5798 49.8283 83.1298 48.6783 86.6598C43.9183 83.8298 40.7383 78.6698 40.7383 72.7898V69.5098H73.5183Z"
        fill="#414141"
      />
      <path
        d="M88.0983 36.83C90.5983 39.3 90.5983 43.3 88.0983 45.76L78.1683 55.57L68.2383 45.76C65.7283 43.28 65.7483 39.28 68.2383 36.83C70.7383 34.36 74.7883 34.36 77.2783 36.83L78.1583 37.7L79.0383 36.83C80.2883 35.6 81.9283 34.9801 83.5583 34.9801C85.1883 34.9801 86.8283 35.6 88.0783 36.83H88.0983Z"
        fill="#C45361"
      />
      <path
        d="M46.0202 45.7698L36.0902 55.5798L26.1602 45.7698C23.6502 43.2898 23.6702 39.2898 26.1602 36.8398C28.6602 34.3698 32.7002 34.3698 35.2002 36.8398L36.0802 37.7098L36.9602 36.8398C38.2102 35.6098 39.8402 34.9898 41.4802 34.9898C47.1402 34.9898 50.0402 41.7898 46.0002 45.7698H46.0202Z"
        fill="#C45361"
      />
      <path
        d="M101.299 104.759C102.509 104.759 103.489 103.792 103.489 102.599C103.489 101.407 102.509 100.439 101.299 100.439C100.09 100.439 99.1094 101.407 99.1094 102.599C99.1094 103.792 100.09 104.759 101.299 104.759Z"
        fill="#010101"
      />
      <path
        d="M10.1588 16.0602C11.3683 16.0602 12.3488 15.0932 12.3488 13.9003C12.3488 12.7073 11.3683 11.7402 10.1588 11.7402C8.94925 11.7402 7.96875 12.7073 7.96875 13.9003C7.96875 15.0932 8.94925 16.0602 10.1588 16.0602Z"
        fill="#010101"
      />
      <path
        d="M27.0498 37.7204C25.0398 39.7004 25.0398 42.9104 27.0498 44.8904L36.0899 53.8204L45.1298 44.8904C49.9398 40.1504 42.6698 32.9704 37.8699 37.7204C37.1599 38.3304 36.8899 38.9604 36.0899 38.9604C35.2899 38.9604 35.0198 38.3304 34.3098 37.7204C32.2998 35.7404 29.0598 35.7404 27.0498 37.7204ZM35.1998 56.4604L25.2698 46.6504C22.2798 43.7004 22.2798 38.9104 25.2698 35.9604C28.2598 33.0104 33.0899 33.0004 36.0899 35.9604C37.5299 34.5404 39.4498 33.7504 41.4898 33.7504C45.7198 33.7504 49.1498 37.1304 49.1498 41.3104C49.1498 43.3304 48.3498 45.2304 46.9098 46.6604L36.9798 56.4704C36.4898 56.9604 35.6898 56.9604 35.1998 56.4704V56.4604Z"
        fill="#010101"
      />
      <path
        d="M69.1278 37.7204C67.1178 39.7004 67.1178 42.9104 69.1278 44.8904L78.1678 53.8204L87.2078 44.8904C88.1778 43.9304 88.7078 42.6604 88.7078 41.3104C88.7078 38.5104 86.4078 36.2404 83.5778 36.2404C82.2078 36.2404 80.9178 36.7704 79.9478 37.7304C79.2378 38.3404 78.9678 38.9704 78.1678 38.9704C77.3678 38.9704 77.0978 38.3404 76.3878 37.7304C74.3878 35.7504 71.1378 35.7504 69.1278 37.7304V37.7204ZM77.2778 56.4604L67.3478 46.6504C64.3478 43.6904 64.3578 38.9104 67.3478 35.9604C70.3378 33.0104 75.1778 33.0004 78.1678 35.9604C81.1678 33.0104 85.9978 33.0204 88.9878 35.9604C91.9778 38.9204 91.9778 43.7004 88.9878 46.6504L79.0578 56.4604C78.5678 56.9504 77.7678 56.9504 77.2778 56.4604Z"
        fill="#010101"
      />
      <path
        d="M48.2994 87.8499C47.6394 87.6399 47.2694 86.9398 47.4894 86.2798C48.8394 82.1298 52.7194 79.3398 57.1394 79.3398C61.5594 79.3398 65.4294 82.1298 66.7894 86.2798C66.9994 86.9298 66.6394 87.6399 65.9794 87.8499C65.3194 88.0599 64.6094 87.6998 64.3894 87.0498C63.3694 83.9298 60.4594 81.8298 57.1394 81.8298C53.8194 81.8298 50.9094 83.9299 49.8894 87.0399C49.6794 87.6999 48.9594 88.0498 48.2994 87.8398V87.8499Z"
        fill="#010101"
      />
      <path
        d="M42.0005 70.7595V72.7995C42.0005 81.2695 48.9605 87.7395 57.1305 87.7395C65.3005 87.7395 72.2605 81.2595 72.2605 72.7995V70.7595H42.0005ZM57.1305 90.2296C47.6105 90.2296 39.4805 82.6795 39.4805 72.7995V69.5195C39.4805 68.8295 40.0405 68.2695 40.7405 68.2695H73.5205C74.2205 68.2695 74.7805 68.8295 74.7805 69.5195V72.7995C74.7805 78.9695 71.5805 84.5495 66.2305 87.7395C63.4905 89.3695 60.3405 90.2296 57.1305 90.2296Z"
        fill="#010101"
      />
      <path
        d="M57.1283 6.33008C28.6683 6.33008 5.50827 29.2001 5.50827 57.3201C5.50827 85.4401 28.6683 108.31 57.1283 108.31C85.5883 108.31 108.748 85.4401 108.748 57.3201C108.748 29.2001 85.5883 6.33008 57.1283 6.33008ZM57.1283 110.79C27.2083 110.79 2.98828 86.8701 2.98828 57.3101C2.98828 27.7501 27.2783 3.83008 57.1283 3.83008C86.9783 3.83008 111.268 27.8201 111.268 57.3101C111.268 86.8001 87.0583 110.79 57.1283 110.79Z"
        fill="#010101"
      />
      <path
        d="M108.09 2.48004C105.86 2.48004 104.04 4.28004 104.04 6.48004C104.04 8.68004 105.86 10.48 108.09 10.48C110.32 10.48 112.14 8.68004 112.14 6.48004C112.14 4.28004 110.32 2.48004 108.09 2.48004ZM108.09 12.98C104.47 12.98 101.52 10.07 101.52 6.48999C101.52 2.90999 104.47 0 108.09 0C111.71 0 114.66 2.90999 114.66 6.48999C114.66 10.07 111.71 12.98 108.09 12.98Z"
        fill="#010101"
      />
      <path
        d="M5.71002 103.85C3.95002 103.85 2.52002 105.26 2.52002 107C2.52002 108.74 3.95002 110.15 5.71002 110.15C7.47002 110.15 8.90002 108.74 8.90002 107C8.90002 105.26 7.47002 103.85 5.71002 103.85ZM5.71002 112.64C2.56002 112.64 0 110.11 0 107C0 103.89 2.56002 101.36 5.71002 101.36C8.86002 101.36 11.42 103.89 11.42 107C11.42 110.11 8.86002 112.64 5.71002 112.64Z"
        fill="#010101"
      />
    </svg>
  ),
  StarIcon: (props) => (
    <svg
      width="42"
      height="44"
      viewBox="0 0 42 44"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M40.2686 20.1206L33.0616 27.7366L34.7641 38.4872C34.9939 39.947 34.4508 41.3955 33.3436 42.2669C32.7169 42.7648 31.9858 43.0138 31.2442 43.0138C30.6802 43.0138 30.1057 42.8666 29.5834 42.5611L20.6739 37.48L11.7644 42.5611C10.5527 43.2514 9.11136 43.1382 8.0042 42.2669C6.89704 41.3955 6.35391 39.947 6.5837 38.4872L8.28623 27.7366L1.0792 20.1206C0.0973778 19.0908 -0.24729 17.5631 0.180953 16.1599C0.609195 14.7453 1.70592 13.7382 3.06377 13.5231L13.0282 11.9501L17.4882 2.16144C18.094 0.826104 19.3265 0 20.6948 0C22.0631 0 23.2956 0.826104 23.9014 2.16144L28.3614 11.9501L38.3259 13.5231C39.6837 13.7382 40.7804 14.7453 41.2086 16.1599C41.6369 17.5744 41.2817 19.0908 40.2999 20.1206H40.2686Z"
        fill="currentColor"
      />
    </svg>
  ),
  BackSpaceIcon: (props) => (
    <svg
      width="58"
      height="60"
      viewBox="0 0 58 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.8802 11L0 30.5L12.8802 50H54.0942C56.2496 50 58 48.238 58 46.0685V14.9447C58 12.7751 56.2496 11.0131 54.0942 11.0131H12.8802V11Z"
        fill="currentColor"
      />
      <path
        d="M41.445 39H36.65L31.96 32.14L27.305 39H22.51L29.615 29.48L22.965 20.45H27.62L31.96 26.82L36.3 20.45H40.955L34.34 29.48L41.445 39Z"
        fill="transparent"
      />
    </svg>
  ),
  FunLogoWithBGBigIcon: (props) => (
    <svg
      width="1111"
      height="465"
      viewBox="0 0 1111 465"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="1.5"
        y="1.5"
        width="1108"
        height="462"
        rx="45.5"
        fill="#F8B6BA"
        stroke="#C45361"
        strokeWidth="3"
      />
      <g clipPath="url(#clip0_8507_2)">
        <path
          d="M624.711 278.136H592.988V173.858C592.988 161.173 599.227 154.831 611.652 154.831H696.247V179.513H633.012C629.946 179.513 627.831 180.147 626.562 181.363C625.346 182.579 624.711 184.746 624.711 187.811V204.195H678.641V228.878H624.711V278.189V278.136Z"
          fill="white"
        />
        <path
          d="M817.798 229.512V154.831H849.522V231.097C849.522 248.856 844.71 261.329 835.14 268.623C825.571 275.916 811.189 279.563 792.05 279.563C772.91 279.563 758.529 275.916 748.959 268.623C739.389 261.329 734.578 248.856 734.578 231.097V154.831H766.301V229.512C766.301 238.338 768.363 244.733 772.54 248.803C776.717 252.873 783.22 254.881 791.997 254.881C800.774 254.881 807.277 252.873 811.454 248.803C815.631 244.733 817.693 238.338 817.693 229.512H817.798Z"
          fill="white"
        />
        <path
          d="M1022.2 154.831V259.797C1022.2 265.082 1020.46 269.68 1017.02 273.644C1013.53 277.555 1007.77 279.564 999.678 279.564C988.998 279.564 981.173 275.811 976.256 268.306L928.143 195.898C926.874 193.889 925.71 192.885 924.812 192.885C923.384 192.885 922.697 194.048 922.697 196.426V278.137H895.891V172.801C895.891 166.353 898.006 161.491 902.341 158.267C906.624 155.043 912.228 153.404 919.154 153.404C929.623 153.404 937.184 156.945 941.889 163.975L990.32 237.07C990.32 237.07 990.637 237.493 990.954 238.021C991.219 238.55 991.483 238.92 991.642 239.078C991.8 239.237 992.065 239.448 992.435 239.713C992.805 239.924 993.122 240.083 993.492 240.083C994.761 240.083 995.448 239.078 995.448 237.07V154.831H1022.25H1022.2Z"
          fill="white"
        />
        <path
          d="M591.031 372.162V359.636H625.821C627.143 359.636 628.147 359.372 628.887 358.79C629.628 358.209 629.998 357.68 630.156 357.152C630.262 356.623 630.315 356.042 630.315 355.302C630.315 352.924 628.676 351.232 625.451 350.175L600.918 342.829C597.058 341.719 594.309 339.658 592.723 336.751C591.137 333.844 590.344 329.985 590.344 325.282C590.344 314.711 595.208 309.426 604.884 309.426H643.586V321.952H611.122C608.214 321.952 606.734 323.326 606.734 326.074C606.734 328.558 608.426 330.355 611.757 331.36L633.804 337.808C638.51 339.182 641.894 341.19 643.85 343.833C645.806 346.475 646.811 350.334 646.811 355.46C646.811 366.56 642.052 372.109 632.483 372.109H591.084L591.031 372.162Z"
          fill="white"
        />
        <path
          d="M704.759 372.162H688.633V322.005H665.316V309.479H728.022V322.005H704.706V372.162H704.759Z"
          fill="white"
        />
        <path
          d="M791.151 347.427V309.426H807.277V348.22C807.277 357.257 804.845 363.6 799.98 367.299C795.116 370.999 787.82 372.849 778.092 372.849C768.363 372.849 761.067 370.999 756.203 367.299C751.338 363.6 748.906 357.257 748.906 348.22V309.426H765.032V347.427C765.032 351.919 766.09 355.196 768.204 357.257C770.319 359.319 773.65 360.323 778.092 360.323C782.533 360.323 785.864 359.319 787.979 357.257C790.093 355.196 791.151 351.919 791.151 347.427Z"
          fill="white"
        />
        <path
          d="M868.503 372.162H842.49C836.145 372.162 832.973 368.991 832.973 362.595V319.151C832.973 312.703 836.145 309.479 842.49 309.479H867.657C872.732 309.479 877.015 310.218 880.452 311.698C883.941 313.178 886.585 315.398 888.382 318.305C890.18 321.212 891.449 324.489 892.189 328.03C892.929 331.571 893.247 335.852 893.247 340.82C893.247 345.788 892.876 349.964 892.189 353.558C891.449 357.152 890.233 360.376 888.488 363.335C886.743 366.242 884.153 368.462 880.822 369.942C877.491 371.422 873.367 372.162 868.45 372.162H868.503ZM849.151 326.444V355.09C849.151 356.782 849.469 357.944 850.103 358.579C850.738 359.213 851.901 359.583 853.646 359.583H857.294C864.643 359.583 869.719 358.314 872.574 355.725C875.429 353.135 876.856 348.167 876.856 340.767C876.856 333.368 875.429 328.4 872.574 325.81C869.719 323.22 864.643 321.952 857.294 321.952H853.646C851.901 321.952 850.738 322.269 850.103 322.956C849.469 323.643 849.151 324.753 849.151 326.444Z"
          fill="white"
        />
        <path
          d="M933.376 372.162H917.25V309.479H933.376V372.162Z"
          fill="white"
        />
        <path
          d="M974.985 310.06C979.004 309.161 984.238 308.738 990.688 308.738C997.139 308.738 1002.37 309.214 1006.39 310.06C1010.41 310.958 1013.79 312.597 1016.54 314.975C1019.34 317.353 1021.25 320.63 1022.36 324.753C1023.47 328.875 1024 334.213 1024 340.767C1024 347.321 1023.47 352.659 1022.36 356.781C1021.25 360.904 1019.29 364.181 1016.54 366.612C1013.74 369.043 1010.36 370.682 1006.39 371.527C1002.37 372.373 997.139 372.849 990.688 372.849C984.238 372.849 979.004 372.426 974.985 371.527C970.967 370.682 967.583 369.043 964.834 366.612C962.085 364.181 960.128 360.904 959.018 356.781C957.908 352.659 957.379 347.321 957.379 340.767C957.379 334.213 957.908 328.875 959.018 324.753C960.128 320.63 962.085 317.353 964.834 314.975C967.636 312.597 971.02 310.958 974.985 310.06ZM977.312 325.493C974.985 328.241 973.822 333.368 973.822 340.82C973.822 348.272 974.985 353.399 977.364 356.2C979.744 359.001 984.185 360.375 990.688 360.375C997.191 360.375 1001.63 359.001 1004.01 356.2C1006.39 353.399 1007.55 348.325 1007.55 340.82C1007.55 333.315 1006.39 328.241 1004.01 325.44C1001.63 322.639 997.191 321.264 990.688 321.264C984.185 321.264 979.744 322.691 977.312 325.493Z"
          fill="white"
        />
        <path
          d="M498.295 157.051H385.519C379.333 157.051 375.579 163.816 378.857 169.048C382.664 175.179 385.731 181.839 387.898 188.868H387.846C390.331 196.954 391.652 205.358 391.652 213.867C391.652 260.483 353.743 298.379 307.11 298.379C260.477 298.379 222.568 260.483 222.568 213.867C222.568 198.117 226.956 182.737 235.31 169.365C236.843 166.881 236.949 163.763 235.522 161.226C234.094 158.689 231.398 157.104 228.49 157.104H117.723V143.468C117.723 127.083 130.994 113.817 147.384 113.817H214.109C218.656 113.817 223.044 111.862 226.058 108.373C228.595 105.467 229.97 101.767 229.97 97.9086C229.97 89.1351 222.832 82.0528 214.109 82.0528H147.384C113.493 82 86 109.483 86 143.415V367.88C86 376.759 93.2434 384.158 102.126 384C110.744 383.841 117.723 376.812 117.723 368.144V188.762H193.541C191.744 196.954 190.792 205.358 190.792 213.814C190.792 277.925 242.977 330.037 307.057 330.037C371.138 330.037 423.323 277.872 423.323 213.814C423.323 205.358 422.371 196.902 420.573 188.762H483.385C491.633 188.762 498.295 195.422 498.295 203.667V304.985C498.295 330.777 477.358 351.707 451.556 351.707H380.549C371.667 351.707 364.265 358.948 364.423 367.827C364.582 376.706 371.614 383.419 380.285 383.419H451.556C494.911 383.419 530.071 348.272 530.071 304.932V188.762C530.071 171.162 515.795 156.945 498.242 156.945L498.295 157.051Z"
          fill="white"
        />
        <path
          d="M352.473 178.879C342.004 165.243 325.508 156.47 306.95 156.47C275.227 156.47 249.531 182.156 249.531 213.868C249.531 224.227 252.281 234.005 257.145 242.408C267.032 259.638 285.643 271.266 306.95 271.266C338.673 271.266 364.369 245.579 364.369 213.868C364.369 200.707 359.928 188.604 352.473 178.932V178.879ZM307.003 260.272C289.82 260.272 274.804 250.653 266.926 236.436C263.225 229.723 261.11 222.06 261.11 213.815C261.11 188.234 281.677 167.357 307.003 167.357C321.437 167.357 334.391 174.175 342.797 184.746C349.089 192.727 352.896 202.769 352.896 213.762C352.896 239.343 332.329 260.219 307.003 260.219V260.272Z"
          fill="white"
        />
        <path
          d="M334.656 190.189C327.994 182.209 318.107 177.082 307.004 177.082C287.072 177.082 270.84 193.572 270.84 213.815C270.84 220.051 272.373 225.865 275.07 230.992C281.15 242.619 293.205 250.494 307.004 250.494C314.935 250.494 322.231 247.852 328.206 243.465C325.404 242.672 323.024 241.034 321.28 238.814C320.328 237.545 319.588 236.118 319.165 234.533C318.795 233.37 318.583 232.102 318.583 230.833C318.583 223.592 324.452 217.673 331.748 217.673C335.925 217.673 339.679 219.628 342.058 222.694C342.746 219.84 343.169 216.827 343.169 213.762C343.169 204.777 339.943 196.532 334.656 190.137V190.189Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_8507_2">
          <rect
            width="938"
            height="302"
            fill="white"
            transform="translate(86 82)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  RoundIcon: (props) => (
    <svg
      width="34"
      height="40"
      viewBox="0 0 34 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.8334 27.6667H30.4167V37.25M13.1667 12.3333H3.58339V2.75M31.2179 14.2558C30.1433 11.5958 28.3439 9.29064 26.0245 7.60236C23.705 5.91407 20.9584 4.91035 18.0969 4.70531C15.2354 4.50026 12.3737 5.1021 9.83725 6.44241C7.30075 7.78273 5.19115 9.80777 3.74823 12.2873M2.78223 25.7442C3.85708 28.4037 5.6564 30.7084 7.97568 32.3963C10.295 34.0842 13.0412 35.0877 15.9024 35.2927C18.7635 35.4978 21.6248 34.8961 24.1611 33.5562C26.6973 32.2162 28.8069 30.1917 30.25 27.7127"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  TakePhotoThumbnailHolderIcon: (props) => (
    <svg
      width="82"
      height="82"
      viewBox="0 0 82 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="82"
        y="3.58433e-06"
        width="82"
        height="82"
        rx="10"
        transform="rotate(90 82 3.58433e-06)"
        fill="white"
      />
      <rect
        x="77"
        y="5"
        width="72"
        height="72"
        rx="11"
        transform="rotate(90 77 5)"
        fill="white"
        stroke="currentColor"
        strokeWidth="2"
        strokeDasharray="6 6"
      />
      <path
        d="M27.4858 39.4886L50.9233 39.4886L50.9233 43.4659L27.4858 43.4659L27.4858 39.4886ZM37.2159 29.7585L41.1932 29.7585L41.1932 53.196L37.2159 53.196L37.2159 29.7585Z"
        fill="currentColor"
      />
    </svg>
  ),
  RefreshIcon: (props) => (
    <svg
      width="47"
      height="38"
      viewBox="0 0 47 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.0046 17.3182L40.4174 11.7161C39.6851 11.0543 38.5816 11.0543 37.9189 11.7161L35.124 14.5184L32.2595 17.3182C31.6716 18.0549 31.8934 18.5694 32.7726 18.5694H36.0832C36.0832 25.7924 30.2742 31.6892 23.0728 31.6892C19.4709 31.6892 16.1629 30.2157 13.8089 27.858L9.47467 32.2037C13.0018 35.7428 17.7073 37.8781 23.0728 37.8781C33.7317 37.8781 42.2583 29.1842 42.2583 18.5694H45.4168C46.5203 18.5694 46.6647 18.0549 46.0046 17.3182ZM14.1054 20.4126C14.7654 19.8232 14.5463 19.1614 13.5897 19.1614H10.2817C10.2817 11.9384 16.0881 6.18894 23.292 6.18894C26.894 6.18894 30.1994 7.59011 32.5534 9.9478L36.8902 5.52713C33.51 2.13536 28.6601 0 23.292 0C12.7079 0 4.10913 8.54663 4.10913 19.1614H0.948086C-0.0832513 19.1614 -0.302411 19.8232 0.434996 20.4126L3.22734 23.2874L6.01969 26.0871C6.68232 26.8239 7.85547 26.8239 8.44591 26.0871L11.3852 23.2874L14.1054 20.4126Z"
        fill="currentColor"
      />
    </svg>
  ),
  MenuIcon: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
      />
    </svg>
  ),
  RotateLeftIcon: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
      fill="currentColor"
      {...props}
    >
      <path d="M440-80q-50-5-96-24.5T256-156l56-58q29 21 61.5 34t66.5 18v82Zm80 0v-82q104-15 172-93.5T760-438q0-117-81.5-198.5T480-718h-8l64 64-56 56-160-160 160-160 56 58-62 62h6q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-438q0 137-91 238.5T520-80ZM198-214q-32-42-51.5-88T122-398h82q5 34 18 66.5t34 61.5l-58 56Zm-76-264q6-51 25-98t51-86l58 56q-21 29-34 61.5T204-478h-82Z" />
    </svg>
  ),
  FlipIcon: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
      fill="currentColor"
      {...props}
    >
      <path d="M360-120H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h160v80H200v560h160v80Zm80 80v-880h80v880h-80Zm160-80v-80h80v80h-80Zm0-640v-80h80v80h-80Zm160 640v-80h80q0 33-23.5 56.5T760-120Zm0-160v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160v-80q33 0 56.5 23.5T840-760h-80Z" />
    </svg>
  ),
};
